import {
  memberImproveRecords,
  getSellerCheckCode,
  exportRecord,
  getUnlockRecord,
  goodRecords
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { searchInvite } from "@/api/jhk/integralCenter/integralTask";
import echarts from "echarts";
import {
  checkRecord,
  checkListBu,
  getCouponData,
  getTrialRebuyData,
  trialRebuyRecord,
  getCouponTable,
  checkList,
  awardRecord,
  awardRecNew,
  inKindList,
  exportRecNew,
  improveList,
  signIssuance,
  getShopGiftParticipateConver,
  getSplitCouponlist,
  getStatisticsCouponlist,
  CouponDetail,
  CouponDetailmember,
  commentDraw,
  getExportCode,
  getExportxlxs,
  getExportLockRight,
  getExportLockWin,
  participation,
  lockRecordPage,
  joinRecordPage,
  getLuckValueRecord,
  memberUpGrade,
  BilletDoux,
  BilletReceive,
  gameTaskRecord,
  markDeliveryStatus,
  DeliveryStatus,
  markingSendStatus,
  getActivityRuleFields,
  getSmartDataDetail,
  getSmartDataSum,
  getExchangeActivityRecord,
  splitCouponPage,
  splitCouponGroup,
  splitCouponStatistics,
  groupMember,
  getGoodRecords,
  awardRecNewOne,
  invaidStatics,
  invitationDetailNew,
  addCartpage,
  lockRightRecord,
  lockWinRecord,
  addCartDetail,
  getSumLockEffectJi,
  getDetailLockEffectJi,
  exportJi,
  getDataOverview,
  getDetailPage,
  getExport,
  getWinRecordPage,
  getGoodsRecordPage,
  winRecordExport,
  goodsRecordExport,
  getOrderRecordPage,
  orderRecordPageExport,
  getSumEffect,
  getDetailEffect,
  getDetailIncludeTotal,
  sendSampleRecordExport,
  exportRecord as winnRecord,
  exportAwardRecord,
  exportPointActivityPrizeDetailBlob,
  exportInviteCardAwardRecord,
  getPrizeNames,
  lockRecordExport,
  getInviteDetail,
  exportStatistics,
  exportTableStatistics,
  joinRecordExport,
  getTrialActivityRecord,
  exportZeroTrialRecord,
  trialRebuyConfig,
  trialRebuyConfigOrder,
  trialLins,
  saveUserCardDetail,
  gachaRecordList,
  exportGachaRecords,
  exportStatisticsTrial,
  exportSum,
  trialRebuyExports, 
  exportLuckValue,
  getLockOrderPage,
  teamSharePrizeRecords,
  exportTeamSharePrizeRecords,
  memberInviteDetails,
  exportMemberInviteDetails,
  taskCompletion,
  exportGameTaskRecord,
  participationPagetion,
  fansExport,
  joinRecordGift,
  exportMemberGift,
  salesRankSummary,
  rank,
  rankDetail,
  rankExportDetail,
  orderDetailPage,
  userProfile,
  rankingRecords,
  exportJoinRecords,
  userLifeRecords,
  orderDetailPages,
  exportuserLife,
  userLifeCycle,
  exportMemberAddCartRecord,
  joinGameRecords,
  exportFunGame,
  joinGamedetail,
  joinGamedetailOne,
  BilletDouxTen,
  exportTicketPayRecord,
  BilletDouxEleven,
  exportBidRecords,
  exportDealRecords,
  BilletDouxTwelve,
  remainScore,
  joinInviteDetail,
  getShoppingCartKoiJoinRecord,
  exportShoppingCartKoiJoinRecord,
  getShoppingCartKoiInviteRecord,
  exportShoppingCartKoiInviteRecord,
  participationFixedPrice,
  exportParticipationFixedPrice,
  markSendWithOrder,
  exportLockOrder,
  exportTrialRecord,
  exportPublics,
  pointActivityPrizeWinUserCount,
  winRecordWinUserCount,
  trialActivityRebuyWinRecordWinUserCount
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import {
  getUserProfileList,
  getUserProfileStatic,
  exportPlatformUserProfile,
  exportPrizeDetail,
  exportMemberDetail,
  exportBilletDetail,
  exportBilletReceive,
} from "@/api/jhk/politely";
import {
  getQuestionnaireRecord,
  exportQuestionnaireRecord,
  trialRebuyExport,
  winRecordExports
} from "@/api/jhk/questionnaire.js";
var pins = "";
export default {
  methods: {
    //趣味游戏参与记录
    gameDetailChang(val){
      // 提取公共参数
      const params = {
        activityId: this.formList.activityId,
        current: 1,
        size: 99999,
        pin: val.mixPin
      };
      remainScore(params).then((res) => {
        this.remainScores = res.data;
      })

      // 选择API调用
      const apiCall = val.prizeGetType == 0 ? joinGamedetail(params) : joinGamedetailOne(params);

      apiCall.then((res) => {
      // 根据类型更新不同的变量
      if (val.prizeGetType == 0) {
        this.gameDetail = res.data.records;
      } else {
        this.gameDetail1 = res.data.records;
        }
      })
     .catch((error) => {
       console.error('获取游戏详情失败:', error);
       // 可以在这里添加错误提示给用户
     });
    },
    // 查看加购详情
    checkCartDetail(row) {
      addCartDetail(row.id)
        .then((res) => {
          this.addCartDetailShow = true;
          this.addCartDetailData = res.data;
        })
        .catch((res) => {});
    },
    invitationDeatils(val) {
      pins = val.pin;
      this.dialogDeatils = true;
      this.formList1.size = 10;
      this.formList1.current = 1;
      if (this.isTaskPrize) {
        this.taskIndex = val.taskIndex;
      }
      this.invitationDetailNews();
    },
    invitationDetailNews() {
      this.loading1 = true;
      let params = {
        ...this.formList,
      };
      params.pin = pins;
      params.size = this.formList1.size;
      params.current = this.formList1.current;
      if (this.isTaskPrize) {
        params.taskIndex = this.taskIndex;
      }
      invitationDetailNew(params).then((res) => {
        console.log("🐉🐉🐉 ~ invitationDetailNew ~ res:", res);
        this.loading1 = false;
        this.CouponMember1 = res.data.records;
        this.totalNum = Number(res.data.total);
      });
    },
    batchMark(source) {
      if (!this.multipleSelection.length)
        return this.$message.warning("请先勾选有效数据再操作");
      let ids = this.multipleSelection.map((item) => item.id);
      if (this.fitersChooseIF([33])) {
        ids = this.multipleSelection.map((item) => item.recordId);
      }
      if (this.fitersChooseIF([9])) {
        markDeliveryStatus(ids).then((res) => {
          if (res.code == 1) {
            this.getList();
            this.multipleSelection = [];
            this.$refs.awardTableRef &&
              this.$refs.awardTableRef.clearSelection();
            this.$message.success(res.message);
          } else {
            this.$message.warning(res.message);
          }
        });
      } else {
        markingSendStatus(source, ids).then((res) => {
          if (res.code == 1) {
            if (this.fitersChooseIF([33])) {
              if (source == 1) this.winningRecord();
            } else {
              if (source == 1) this.inKingRecord();
            }
            if (source == 2) this.winningRecord();
            this.multipleSelection = [];
            this.$message.success(res.message);
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    // 批量标记发货-兑换实物
    batchMark2() {
      this.batchMarkVisible = true;
    },
    // 关闭批量标记发货
    batchMarkClose() {
      this.batchMarkVisible = false;
    },
    // 批量标记发货
    batchMarkForShipment() {
      // if(this.fitersChooseIF([33])) {
      //   ids = this.multipleSelection.map((item) => item.recordId);
      // }
      this.physicalBatchShipmentShow = true;
    },
    // 多选
    handleSelectionChange(val) {
      console.log("🚀 ~ handleSelectionChange ~ val:", val);
      this.multipleSelection = val;
    },
    // 导出
    export_fun() {
      this.$refs.export_fun_sw.export_fun();
    },
    export_get(params) {
      let copyParams = JSON.parse(JSON.stringify(params));
      if(copyParams.prizeIds&&copyParams.prizeIds.length){
        copyParams.prizeIds = copyParams.prizeIds.join(',')
      }
      this.ExprotData = copyParams;
      this.control2 = true;
    },
    exportFunGameRecords(exportRemark){
      let activityId = this.formList.activityId;
      const formData = this.formList
      let params = {
        activityId: activityId,
        pin: formData.pin ? formData.pin : "",
        memberNick: formData.memberNick ? formData.memberNick : "",
        sellerLinkId: formData.sellerLinkId ? formData.sellerLinkId : "",
        firstStartTime: formData.firstStartTime ? formData.firstStartTime : "",
        firstEndTime: formData.firstEndTime ? formData.firstEndTime : "",
        lastStartTime: formData.lastStartTime ? formData.lastStartTime : "",
        lastEndTime: formData.lastEndTime ? formData.lastEndTime : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      }
       exportFunGame(params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
       })
    },
    async getphone() {
      this.control4 = true;
    },
    //购物车锦鲤
    exportCardRecordRecords(exportRemark){
      let activityId = this.formList.activityId;
      const formData = this.formList
      let params = {
        activityId: activityId,
        pin: formData.pin ? formData.pin : "",
        memberNick: formData.memberNick ? formData.memberNick : "",
        joinTimeStart: formData.joinTimeStart ? formData.joinTimeStart : "",
        joinTimeEnd: formData.joinTimeEnd ? formData.joinTimeEnd : "",
        isPass: formData.isPass !== null && formData.isPass !== undefined && formData.isPass !== "" ? formData.isPass : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      }
       exportShoppingCartKoiJoinRecord(params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
       })
    },
    //购物车锦鲤邀请记录
    exportCardInviteRecords(exportRemark){
      let activityId = this.formList.activityId;
      const formData = this.formList
      let params = {
        activityId: activityId,
        invitePin: formData.invitePin ? formData.invitePin : "",
        inviteNick: formData.inviteNick ? formData.inviteNick : "",
        assistTimeStart: formData.assistTimeStart ? formData.assistTimeStart : "",
        assistTimeEnd: formData.assistTimeEnd ? formData.assistTimeEnd : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      }
       exportShoppingCartKoiInviteRecord(params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
       })
    },
    exportFixedPriceRecords(exportRemark){
      let activityId = this.formList.activityId;
      const formData = this.formList
      let params = {
        activityId: activityId,
        joinTimeStart: formData.joinTimeStart ? formData.joinTimeStart : "",
        joinTimeEnd: formData.joinTimeEnd ? formData.joinTimeEnd : "",
        memberNick: formData.memberNick ? formData.memberNick : "",
        pin: formData.pin ? formData.pin : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      }
       exportParticipationFixedPrice(params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
       })

    },
    //晒单有礼-订单明细导出
    exportPublic(exportRemark){
      let obj =  this.formOrderDetailQuery
      let params = {
        ...obj,
        activityId:this.formList.activityId,
        current: 1,
        size: 9999999,
        exportRemark: exportRemark,
      };
      if(this.rowData.activityType==68) {
        params = {activityId:this.formList.activityId, exportRemark: exportRemark,...this.formListLockFans}
      }
       exportPublics(params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
       })
    },
    exportLockOrderRecords(exportRemark){
      let activityId = this.formList.activityId;
      const formData = this.formLockOrder
      let params = {
        activityId: activityId,
        pin: formData.pin ? formData.pin : "",
        orderStartTime: formData.orderStartTime ? formData.orderStartTime : "",
        orderEndTime: formData.orderEndTime ? formData.orderEndTime : "",
        orderStateList: formData.orderStateList ? formData.orderStateList : "",
        orderId: formData.orderId ? formData.orderId : "",
        memberNick: formData.memberNick ? formData.memberNick : "",
        customerPin: formData.customerPin ? formData.customerPin : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      }
       exportLockOrder(params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
       })
    },
    exportTrialRecords(exportRemark){
      let activityId = this.formList.activityId;
      const formData = this.formListLockTrial
      const type = {
        lockJoinRecord1: 0,
        lockJoinRecord2: 1
      }
      let params = {
        activityId: activityId,
        pin: formData.pin ? formData.pin : "",
        orderStartTime: formData.orderStartTime ? formData.orderStartTime : "",
        orderEndTime: formData.orderEndTime ? formData.orderEndTime : "",
        orderStateList: formData.orderStateList ? formData.orderStateList : "",
        orderId: formData.orderId ? formData.orderId : "",
        customerPin: formData.customerPin ? formData.customerPin : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
        orderType: type[this.activeName],
      }
       exportTrialRecord(params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
       })
    },
    exportsalesRankRecords(exportRemark){
      let activityId = this.formList.activityId;
      const formData = this.formListLockFans
      let params = {
        activityId: activityId,
        pin: formData.pin ? formData.pin : "",
        createEndTime: formData.createEndTime ? formData.createEndTime : "",
        orderStartTime: formData.orderStartTime ? formData.orderStartTime : "",
        orderEndTime: formData.orderEndTime ? formData.orderEndTime : "",
        orderState: formData.orderState ? formData.orderState : "",
        orderId: formData.orderId ? formData.orderId : "",
        customerPin: formData.customerPin ? formData.customerPin : "",
        memberNick: formData.memberNick ? formData.memberNick : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      }
      rankExportDetail(params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
       })
    },
    savePhone(exportRemark) {
      let params = {
        endTime: this.formList.endTime,
        startTime: this.formList.startTime,
        activityId: this.formList.activityId,
        exportRemark,
      };

      if (this.fitersChooseIF([9, 10, 29, 30])) {
        exportRecord({ ...this.formList, exportRemark }).then((res) => {
          if (res.code == 1) {
            this.control4 = true;
          } else {
            this.$message.warning(res.message);
          }
        });
      } else if (this.fitersChooseIF([41])) {
        let params1 = {
          ...this.formList,
          exportRemark,
        };
        // 晒单有礼-资料导出
        exportPlatformUserProfile(params1).then((res) => {
          if (res.code == 1) {
            this.control4 = true;
          } else {
            this.$message.warning(res.message);
          }
        });
      } else {
        memberImproveRecords(params).then((res) => {
          if (res.code == 1) {
            this.control4 = true;
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    /** 获取验证码 */
    getCodeInit() {
      if (!this.timer) {
        getSellerCheckCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "重新发送(" + this.countdown + ")";
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "获取验证码";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    getCode() {
      // 验证码60秒倒计时
      if (!this.codeDisabled) {
        getExportCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "已发送(" + this.countdown + "s)";
                  // this.successMsg = "验证码错误！"
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "重新获取";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.successMsg = res.message;
          }
        });
      }
    },
    getApi_Exprot(exportRemark) {
      // 新逻辑 按记录区分导出，因为一种活动 activityType 可能有多种记录需要导出
      if (this.activeName === "eighteen") {
        // 锁权记录
        let obj = this.$refs.export_fun18.export_fun2();
        let params = {
          ...obj,
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
        };
        this.formLoading = true;
        getExportLockRight(params).then((res) => {
          this.formLoading = false;
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "锁权记录" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
            // }
          } else {
            // this.successMsg = res.message;
            this.$message.warning(res.message);
          }
        });
      } else if (this.activeName === "seventeen") {
        // 发货信息
        let obj = this.$refs.export_fun17.export_fun2();
        let params = {
          ...obj,
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
          isReceiveInfo: true,
        };
        if (this.fitersChooseIF([37])) {
          params.subType = "37";
        }
        this.formLoading = true;
        getExportLockWin(params).then((res) => {
          this.formLoading = false;
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "收货信息" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
            // }
          } else {
            // this.successMsg = res.message;
            this.$message.warning(res.message);
          }
        });
      } else if (this.activeName === "sixteen") {
        // 积分锁权-中奖记录
        let obj = this.$refs.export_fun16.export_fun2();
        let params = {
          ...obj,
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
        };
        if (this.fitersChooseIF([37])) {
          params.subType = "37";
        }
        this.formLoading = true;
        getExportLockWin(params).then((res) => {
          this.formLoading = false;
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "中奖名单" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
            // }
          } else {
            // this.successMsg = res.message;
            this.$message.warning(res.message);
          }
        });
      } else if (this.activeName === "first" && this.fitersChooseIF([35])) {
        let tt = "00:00:00",
          tt1 = "23:59:59";
        let params = {
          // startTime = this.postForm.startDate;
          // endTime = this.postForm.endDat
          startTime: this.postForm.startDate || "",
          endTime: this.postForm.endDate || "",
          pin: this.postForm.pin || "",
          activityId: this.formList.activityId,
          code: this.code,
          current: 1,
          size: 9999999,
          channelCode: this.postForm.channelCode,
        };
        if (
          params.startTime.indexOf("00:00:00") != -1 &&
          params.endTime.indexOf("23:59:59") != -1
        ) {
          params.startTime = this.postForm.startDate;
          params.endTime = this.postForm.endDate;
        } else {
          params.startTime = this.postForm.startDate + " 00:00:00";
          params.endTime = this.postForm.endDate + " 23:59:59";
        }
        exportJi(params).then((res) => {
          if (res.code == 1) {
            this.successMsg = "";
            this.dialogExprot = false;
            let Time = new Date().toLocaleString();
            let blob = new Blob([res.blob]);
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "活动统计" + Time + ".xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
          } else {
            this.$message.warning(res.message);
          }
        });
      }else if(this.activeName === "getRecord" && this.fitersChooseIF([39])) {
        this.exportTheData(exportRemark)
      } else if(this.activeName === "thirtyFour") {
        // 加购记录导出
        this.ExprotData.exportRemark = exportRemark;
        exportMemberAddCartRecord(this.ExprotData).then(res=>{
          if(res.code == 1) {
            console.log("导出成功",res);
          } else {
            this.$message.error(res.message);
          }
        })
      } else {
        // 旧逻辑 均按活动 activityType 判断
        let params = {
          ...this.ExprotData,
          activityId: this.formList.activityId,
          current: 1,
          size: 9999999,
          exportRemark,
        };
        if (this.fitersChooseIF([37])) {
          params.subType = "37";
        }
        if (this.$route.query.activityType == 33) {
          let obj = this.$refs.export_fun33.export_fun2();
          params = {
            ...obj,
            activityId: this.formList.activityId,
            code: this.code,
            current: 1,
            size: 9999999,
            subType: 33,
          };
        }
        // 生日有礼-实物奖品名单-导出
        if (this.rowData.activityType == 39) {
          params = {
            activityId: this.formList.activityId,
            pin: this.postForm.pin || "",
            current: 1,
            size: 9999999,
            exportRemark,
            subType: 39,
            ...this.formList
          };
          if (this.formList.memberNick) {
            params.memberNick = this.formList.memberNick;
          }
          if (
            this.formList.deliveryTimeStart &&
            this.formList.deliveryTimeEnd
          ) {
            params.deliveryTimeStart = this.formList.deliveryTimeStart;
            params.deliveryTimeEnd = this.formList.deliveryTimeEnd;
          }
          if (this.formList.sendTimeStart && this.formList.sendTimeEnd) {
            params.sendTimeStart = this.formList.sendTimeStart;
            params.sendTimeEnd = this.formList.sendTimeEnd;
          }
          if (this.formList.status) {
            params.status = this.formList.status;
          }
        }
        if (this.fitersChooseIF([52])) {
          getExportxlxs(params).then((res) => {
          if (res.code == 1) {
            this.control2 = true;
           } else {
             this.$message.error(res.message);
          }
         });
         return
        }
        getExportxlxs(params).then((res) => {
          if (res.code == 1) {
            this.control2 = true;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 打榜有礼 导出
    getApi_Exprot2(tabName = 1, exportRemark) {
      switch (tabName) {
        case 1:
          let params = {
            activityId: this.formList.activityId,
            endTime: this.postForm.endDate || "",
            startTime: this.postForm.startDate || "",
            pin: this.postForm.pin || "",
            exportRemark,
          };
          if (
            params.startTime.indexOf("00:00:00") != -1 &&
            params.endTime.indexOf("23:59:59") != -1
          ) {
            params.startTime = this.postForm.startDate;
            params.endTime = this.postForm.endDate;
          } else {
            params.startTime = this.postForm.startDate + " 00:00:00";
            params.endTime = this.postForm.endDate + " 23:59:59";
          }
          getExport(params)
            .then((res) => {
              if (res.code == 1) {
                this.control3 = true;
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
        case 2:
          // 查询列表
          let formObj2 = this.tabName == "twenty-one" ? this.$refs.export_fun_lj2.export_fun2() : {...this.$refs.export_fun_extra.export_fun2(),prizeObjectType: 1};
          let pamams2 = {
            ...formObj2,
            id: this.tabName == "twenty-one" ? this.formList.activityId : this.formExtra.id,
            exportRemark,
          };
          for (var i in pamams2) {
            if (pamams2[i] + "" == "") {
              pamams2[i] = null;
            }
          }
          winRecordExport(pamams2)
            .then((res) => {
              if (res.code == 1) {
                this.control3 = true;
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {
              this.$message.error(res.message);
            });
          break;
        case 3:
          // 查询列表
          let formObj3 = this.$refs.export_fun_sw2.getSearchForm();
          let copyFormObj3 = JSON.parse(JSON.stringify(formObj3));
          if(copyFormObj3.prizeIds&&copyFormObj3.prizeIds.length){
            copyFormObj3.prizeIds = copyFormObj3.prizeIds.join(',')
          }
          let pamams3 = {
            ...copyFormObj3,
            activityId: this.formList.activityId,
            exportRemark,
            prizeStatus: this.formList.prizeStatus || "",
          };
          goodsRecordExport(pamams3)
            .then((res) => {
              console.log("🚀 ~ .then ~ res:", res);
              if (res.code == 1) {
                this.control3 = true;
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
      }
    },
    // 派样回购礼 导出
    getApi_Exprot3(tabName = 1) {
      switch (tabName) {
        case 1:
          // 活动统计
          let params = {
            activityId: this.formList.activityId,
            code: this.code,
            endTime: this.postForm.endDate || "",
            startTime: this.postForm.startDate || "",
            pin: this.postForm.pin || "",
            current: 1,
            type: 1,
            size: 9999999,
          };
          if (
            params.startTime.indexOf("00:00:00") != -1 &&
            params.endTime.indexOf("23:59:59") != -1
          ) {
            params.startTime = this.postForm.startDate;
            params.endTime = this.postForm.endDate;
          } else {
            params.startTime = this.postForm.startDate + " 00:00:00";
            params.endTime = this.postForm.endDate + " 23:59:59";
          }
          sendSampleRecordExport(params)
            .then((res) => {
              if (res.code == 1) {
                this.dialogExprot = false;
                const href = URL.createObjectURL(res.blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", href);
                a.download = res.fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(href);
              } else {
                this.$message.error("导出失败");
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
        case 2:
          // 派样下单记录
          let params2 = {
            ...this.formList,
            activityId: this.formList.activityId,
            code: this.code,
            current: 1,
            type: 0,
            size: 9999999,
          };
          orderRecordPageExport(params2)
            .then((res) => {
              if (res.code == 1) {
                this.dialogExprot = false;
                const href = URL.createObjectURL(res.blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", href);
                a.download = res.fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(href);
              } else {
                this.$message.error("导出失败");
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
        case 3:
          let params3 = {
            ...this.formList,
            activityId: this.formList.activityId,
            code: this.code,
            current: 1,
            size: 9999999,
            type: 1,
          };
          orderRecordPageExport(params3)
            .then((res) => {
              if (res.code == 1) {
                this.dialogExprot = false;
                const href = URL.createObjectURL(res.blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", href);
                a.download = res.fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(href);
              } else {
                this.$message.error("导出失败");
              }
            })
            .catch(() => {
              this.$message.error(res.code);
            });
          break;
      }
    },
    // 返回value
    fitersTypeValue(val) {
      let arr = [
        "",
        "每日打卡",
        "浏览店铺",
        "浏览商品",
        "加购商品",
        "浏览会场",
        "关注店铺",
        "开卡入会",
        "好友助力",
      ];
      return arr[val];
    },
    // 抽奖机会赠送记录-大转盘
    fitersTypeValue2(val) {
      let arr = [
        { label: "每日签到", value: 1 },
        { label: "浏览店铺", value: 2 },
        { label: "浏览商品", value: 13 },
        { label: "加购商品", value: 4 },
        { label: "分享商品", value: 9 },
        { label: "分享店铺", value: 10 },
        { label: "分享活动", value: 11 },
        { label: "好友助力", value: 8 },
        { label: "浏览会场", value: 5 },
        { label: "预约商品", value: 12 },
        { label: "首次赠送", value: 14 },
        { label: "每日赠送", value: 15 },
        { label: "积分兑换", value: 16 },
        { label: "购买商品", value: 17 },
        { label: "邀请好友入会", value: 18 },
        { label: "加入会员", value: 7 },
        { label: "预售下单", value: 20 },
        { label: "手动变动", value: 19 },
        { label: "搜索关键词", value: 23 },
      ];
      const index = arr.findIndex((item) => item.value == val);
      if (index != -1) {
        return arr[index].label;
      } else {
        return "";
      }
    },
    // 抽奖机会赠送记录-大转盘-赠送记录
    fitersTypeValue3(row) {
      let str = "";
      let arr = [];
      if (row.orderList) {
        row.orderList.forEach((item) => {
          arr.push(item.orderId);
        });
      }
      str = arr.join(",");
      return str;
    },
    // 抽奖机会赠送记录-大转盘-赠送记录
    fitersTypeValue4(row) {
      let arr = [];
      if (row.orderList) {
        row.orderList.forEach((item) => {
          arr.push(
            `订单号：${item.orderId},订单金额：${item.price}元,订单状态：${item.orderState}`
          );
        });
      }
      return arr;
    },
    // 活动类型 三元表达式 判断显示文字
    fitersRepurchase(arr, val1, val2) {
      let isfaly = false;
      arr.forEach((item) => {
        if (this.rowData.activityType == item) {
          isfaly = true;
        }
      });
      return isfaly ? val1 : val2;
    },
    // this.rowData.activityType活动类型判断显示隐藏type === "=="则arr里面显示,type === "！="   则arr里面不显示
    fitersChooseIF(arr, type = "==") {
      if (type === "==") {
        let isfaly = false;
        arr.forEach((item) => {
          if (this.rowData.activityType == item) {
            isfaly = true;
          }
        });
        return isfaly;
      } else {
        let isfaly = true;
        arr.forEach((item) => {
          if (this.rowData.activityType == item) {
            isfaly = false;
          }
        });
        return isfaly;
      }
    },
    //下单转化数据
    getShopGiftParticipateConver() {
      let tt = "00:00:00",
        start = "",
        end = "",
        startTime = "",
        endTime = "",
        tt1 = "23:59:59";
      if (this.queryForm.evaluateTime == 0) {
        if (this.postForm.startDate == "" || this.postForm.endDate == "") {
          this.$message({
            message: "自定义时间不能为空！",
            type: "warning",
          });
          return;
        }
        start = `${this.postForm.startDate} ${tt}`;
        end = `${this.postForm.endDate} ${tt1}`;
      }
      if (this.queryForm.evaluateTime == 0) {
        startTime = start;
        endTime = end;
      } else {
        startTime = this.postForm.startDate;
        endTime = this.postForm.endDate;
      }
      getShopGiftParticipateConver({
        activityId: this.formList.activityId,
        startTime,
        endTime,
        source: this.fitersChooseIF([9, 10, 29, 30, 38,55,58,59,60,61]) ? 2 : 1,
        sellerLinkId: this.queryForm.sellerLinkId,
      })
        .then((res) => {
          if (res.code == 1) {
            this.tatal_num = res.data;
          } else {
            this.$message({
              message: res.data.message,
              type: "warning",
            });
            this.tatal_num = {
              gmv: 0,
              newShopGmv: 0,
              newShopUsers: 0,
              ordNum: 0,
              ordRate: 0,
              users: 0,
            };
          }
        })
        .catch(() => {});
    },
    //返回列表
    toSetting() {
      this.$emit("returnStep");
    },
    //页头点击
    async handleClick(tab, event) {
      this.otherSaearch = null
      this.formList.size = 10;
      this.formList.current = 1;
      // this.totalMail = 0
      this.multipleSelection = [];
      this.tabName = tab.name;
      this.actTab = tab;
      // 活动统计
      if (tab.name === "first") {
        await this.queryTotal();
        this.getShopGiftParticipateConver();
        this.myCharts.resize();
      }
      // 签到纪录
      if (tab.name === "second") {
        this.checkRecord();
      }
      // 补签卡获取记录
      if (tab.name === "secondBu") {
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.sellerLinkId = "";
        this.formList.taskType = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.$nextTick(() => {
          this.$refs.secondBuRef.reData()
        })
        this.checkRecordBu();
      }
      // 中奖记录
      if (tab.name === "third") {
        this.formList.pin = "";
        this.formList.memberNick =  "";
        this.formList.prizeType = "";
        this.formList.unlockOrderId = "";
        this.formList.orderState = "";
        this.formList.isFillAddress = "";
        this.formList.memberLevel = "";
        this.formList.status = "";
        this.formList.sellerLinkId = "";
        this.formList.orderVenderId = "";
        this.formList.prizeIds = "";
        this.formList.winNumMinLimit = "";
        this.formList.winNumMaxLimit = "";
        if (this.fitersChooseIF([68])){
          this.formList.stageIndex = "";
        }
       if (this.fitersChooseIF([16, 17, 18, 23, 24, 27, 28, 31])) {
         this.formList.prizeIds =  "";
       }
       if(this.fitersChooseIF([44, 45, 47, 48, 53])) {
         this.formList.sendStartTime = "";
         this.formList.sendEndTime = "";
       }
       // 积分锁权
       if (this.fitersChooseIF([45])) {
         this.formList.winStartTime = "";
         this.formList.winEndTime = "";
       } else {
         this.formList.startTime = "";
         this.formList.endTime = "";
       }
       // 下单抽奖-添加白名单字段
       if (this.fitersChooseIF([19,16,17,18])) {
         this.formList.isWhite = "";
       }
       // 晒单有礼-订单号
       if (this.rowData.activityType == 41) {
         this.formList.unlockOrderIds = "";
       }
       this.getPrizeNameList()
        this.$refs.inputAwardOneRef.reData()
        this.winningRecord();
      }
      //试用礼领奖记录
      if (tab.name === "thirdTis") {
        this.formListTras.current = 1;
        this.formListTras.size = 10;
        this.formListTras.nickName = '';
        this.formListTras.sendStatusList = [];
        this.formListTras.prizeType = '';
        this.formListTras.prizeIds = '';
        this.formListTras.pin = '';
        this.formListTras.winStartTime = '';
        this.formListTras.winEndTime = '';
        this.formListTras.orderStateList = [];
        this.formListTras.orderId = '';
        this.formListTras.isWin = '';
        this.formListTras.winType = 0;
        this.formListTras.winNumMinLimit = '';
        this.formListTras.winNumMaxLimit = '';
        this.otherSaearch = {winType: 0}
        this.getPrizeNameList()
        this.$refs.inputAwardTrialRef.reData()
        this.trailLin();
      }
      if (tab.name === "thirdTisOne") {
        this.formListTrasOne.current = 1;
        this.formListTrasOne.size = 10;
        this.formListTrasOne.nickName = '';
        this.formListTrasOne.pin = '';
        this.formListTrasOne.sendStatusList = [];
        this.formListTrasOne.prizeType = '';
        this.formListTrasOne.prizeIds = '';
        this.formListTrasOne.winStartTime = '';
        this.formListTrasOne.winEndTime = '';
        this.formListTrasOne.orderStateList = [];
        this.formListTrasOne.orderId = '';
        this.formListTrasOne.isWin = '';
        this.formListTrasOne.winType = 1;
        this.formListTrasOne.winNumMinLimit = '';
        this.formListTrasOne.winNumMaxLimit = '';
        this.otherSaearch = {winType: 1}
        this.getPrizeNameList()
        this.$refs.inputAwardTrialOneRef.reData()
        this.trailLinOne();
      }
      //邀请统计
      if (tab.name === "sevent") {
        this.statistics();
      }
      // 被邀请人明细
      if (tab.name === "inviteeDetails") {
        // 获取活动详情判断不满足的原因
        searchInvite({ id: this.rowData.id }).then((res) => {
          this.nowActType = res.data.ruleDto.inviteRule;
        });
        this.toGetInviteDetail();
      }
      // 入会打榜-被邀请人明细
      if (tab.name === "joinInviteDetails") {
        this.getJoinInviteDetail();
      }
      // 实物奖品
      if (tab.name === "four") {
        this.formList.status = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.formList.sellerLinkId = "";
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.memberLevel = "";
        this.formList.orderId = "";
        this.formList.orderState = "";
        this.formList.prizeStatus = "";
        this.formList.commitAddressFlag = "";
        this.formList.createTimeStart = "";
        this.formList.createTimeEnd = "";
        this.formList.sendTimeStart = "";
        this.formList.sendTimeEnd = "";
        this.formList.deliveryTimeStart = "";
        this.formList.deliveryTimeEnd = "";
        this.formList.orderVenderId = "";
        this.formList.prizeIds = "";
        this.formList.orderVenderId = "";
         if(this.fitersChooseIF([44, 47, 48, 53,64,65,66])){
          this.formList.grantStartTime = "";
          this.formList.grantEndTime = "";
         }
        this.$refs.export_fun_swRef.reData()
        this.inKingRecord();
      } else {
       delete this.formList.prizeIds
      }
      // 用户资料明细
      if (tab.name === "five") {
        let res = await getActivityRuleFields(this.formList.activityId);
        this.RuleFieldsList = res.data.infoNames;
        if (res.data.showAllStaticField) {
          this.RuleFieldsList = [
            "姓名",
            "手机号码",
            "生日",
            "微信",
            "QQ",
            "邮箱",
            "性别",
            "职业",
            "地区",
            "详细地址",
          ];
        }
        if (res.data.showExtendInfo) {
          this.RuleFieldsList.push("扩展信息");
        }

        this.improveRecord();
      }
      //发放记录
      if (tab.name === "six") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.distributionRecord();
      }
      //拼券明细
      if (tab.name === "seven") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.commentDraw();
      }
      //拼券明细
      if (tab.name === "eight") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.CoupondDtails();
      }
      //优惠券统计
      if (tab.name === "nine") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.CouponStatistics();
      }
      //团队详情
      if (tab.name === "ten") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.TeamDetails();
      }
      // 参与记录
      if (tab.name === "eleven") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.getParticipation();
      }
      // 积分锁权-参与记录
      if (tab.name === "lockJoinRecord") {
        this.getParticipationLock();
      }
      //试用复购-参与记录
      if (tab.name === "lockJoinRecordTrial") {
        this.formListLockTrial.current = 1;
        this.formListLockTrial.size = 10;
        this.formListLockTrial.memberNick = ''
        this.formListLockTrial.pin = ''
        this.formListLockTrial.isGetTrialGift = ''
        this.formListLockTrial.isGetFormalGift = ''
        this.formListLockTrial.startTime = ''
        this.formListLockTrial.endTime = ''
        this.formListLockTrial.skuId = ''
        this.formListLockTrial.orderId = ''
        this.$refs.participatLockTrialRef.reData()
        this.getParticipationLockTrial()
      }
      // 打包一口价-参与记录
      if (tab.name === "lockJoinRecordFixedPrice") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.memberNick = ''
        this.formList.pin = ''
        this.formList.joinTimeStart = ''
        this.formList.joinTimeEnd = ''
        this.$refs.participatLockFixedPriceRef.reData()
        this.getParticipationLockFixedPrice()
      }
      //粉丝打卡
      if (tab.name === "lockJoinRecordFans") {
        this.formListLockFans.current = 1;
        this.formListLockFans.size = 10;
        this.formListLockFans.memberNick = ''
        this.formListLockFans.pin = ''
        this.formListLockFans.isPass = ''
        this.formListLockFans.isWin = ''
        this.formListLockFans.createStartTime = ''
        this.formListLockFans.createEndTime = ''
        this.$refs.participatLockFansRef.reData()
        this.getParticipationLockFans()
      }
      //入会
      if (tab.name === "lockJoinRecordGift") {
        this.formListLockFans.current = 1;
        this.formListLockFans.size = 10;
        this.formListLockFans.memberNick = ''
        this.formListLockFans.pin = ''
        this.formListLockFans.isPass = ''
        this.formListLockFans.isWin = ''
        this.formListLockFans.createStartTime = ''
        this.formListLockFans.createEndTime = ''
        this.$refs.participatLockGiftRef.reData()
        this.getParticipationLockGift()
      }
      // 销售打榜-榜单实况
      if (tab.name === "rankingUpdates") {
        this.salesRankSummarys() //汇总
        this.ranks() //榜单实况
      }
      //销售-订单明细
      if (tab.name === "orderRankDetail") {
        this.formListLockFans.current = 1;
        this.formListLockFans.size = 10;
        this.formListLockFans.orderId = ''
        this.formListLockFans.pin = ''
        this.formListLockFans.orderState = ''
        this.formListLockFans.orderStartTime = ''
        this.formListLockFans.orderEndTime = ''
        this.formListLockFans.createEndTime = ''
        this.formListLockFans.memberNick = ''
        this.$refs.participatSalesRankingDetailRef.reData()
        this.showOrderDetail()
      }
      //销售-打榜参与记录
      if (tab.name === "rankParticipation") {
        this.formListLockFans.current = 1;
        this.formListLockFans.size = 10;
        this.formListLockFans.pin = ''
        this.formListLockFans.joinStartTime = ''
        this.formListLockFans.joinEndTime = ''
        this.getRankingRecords()
        this.$refs.participatSalesRankingRef.reData()
      }
      //生命周期参与记录
      if (tab.name === "lifeParticipationRecord") {
        this.formListLockFans.current = 1;
        this.formListLockFans.size = 10;
        this.formListLockFans.pin = ''
        this.formListLockFans.memberNick = ''
        this.formListLockFans.createStartTime = ''
        this.formListLockFans.createEndTime = ''
        this.getRankingRecordsLife()
        this.$refs.participatSalesLife.reData()
      }

      //试用复购-订单明细
      if (tab.name === "lockJoinRecord1"||tab.name === "lockJoinRecord2") {
        this.formListLockOrder.current = 1;
        this.formListLockOrder.size = 10;
        this.formListLockOrder.pin = ''
        this.formListLockOrder.orderId = ''
        this.formListLockOrder.orderStateList = []
        this.formListLockOrder.orderEndTime = ''
        this.formListLockOrder.orderStartTime = ''
        this.formListLockOrder.memberNick = ''
        if(tab.name === "lockJoinRecord1") {
          this.$refs.lockJoinRecordRef.reData()
        }else{
          this.$refs.lockJoinRecordRef2.reData()
        }
        const type = {
          lockJoinRecord1: 0,
          lockJoinRecord2: 1
        }
        this.getParticipationLockTrialOrder(type[tab.name])
      }
      // 锁权订单明细
      if (tab.name === "lockRecordRecord") {
        this.formLockOrder.current = 1;
        this.formLockOrder.size = 10;
        this.formLockOrder.pin = ''
        this.formLockOrder.orderId = ''
        this.formLockOrder.orderStateList = []
        this.formLockOrder.orderEndTime = ''
        this.formLockOrder.orderStartTime = ''
        this.formLockOrder.memberNick = ''
        this.$refs.lockRecordRecordRef.reData()
        this.getLocklOrderDetail()
      }

      // 定时开奖-参与记录
      if (tab.name === "openWinRecord") {
        this.formOpenWin.memberNick = "";
        this.formOpenWin.pin = "";
        this.formOpenWin.sellerLinkId = ""
        this.formOpenWin.createStartTime = "";
        this.formOpenWin.createEndTime = "";
        this.formOpenWin.memberLevel = "";
        this.formOpenWin.isPass = "";
        this.formOpenWin.isWin = "";
        this.formOpenWin.isFillAddress = "";
        this.formOpenWin.current = 1;
        this.formOpenWin.size = 10;
        this.$refs.openWinRecordRef.reData()
        this.getParticipationOpenWin();
      }
      // 定时开奖-幸运值获取记录
      if (tab.name === "luckRecord") {
        this.formLuck.pin = null;
        this.getLuckList();
      }
      // 参与记录(会员升级礼)
      if (tab.name === "MemberUpGrade") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.getMemberUpGrade();
      }
      // 参与记录(0元试用)
      if (tab.name == "zeroTrial") {
        this.formZeroList.current = 1;
        this.formZeroList.size = 10;
        this.formZeroList.memberNick = "";
        this.formZeroList.pin = "";
        this.formZeroList.prizeName = "";
        this.formZeroList.isWin = "";
        this.formZeroList.grantStatus = "";
        this.formZeroList.isAddress = "";
        this.formZeroList.joinStartTime = "";
        this.formZeroList.joinEndTime = "";
        this.formZeroList.grantStartTime = "";
        this.formZeroList.grantEndTime = "";
        this.formZeroList.receiverMobileList = [];
        this.formZeroList.regionList = [];
        this.formZeroList.level = ""
        this.getZeroTrial();
      }
      // 参与记录(0元试用)
      if (tab.name == "trialDetail") {
        this.formZeroDetailList.current = 1;
        this.formZeroDetailList.size = 10;
        this.formZeroDetailList.memberNick = "";
        this.formZeroDetailList.pin = "";
        this.formZeroDetailList.prizeName = "";
        this.formZeroDetailList.startTime = "";
        this.formZeroDetailList.endTime = "";
        this.getZeroTrialDetail();
      }
      // 参与记录(情书贺卡)
      if (tab.name === "BilletDoux") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.memberNick = "";
        this.formList.pin = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.formList.finishedFlag = "";
        this.getBilletDoux();
      }
      // 获取记录(情书贺卡)
      if (tab.name === "BilletDouxReceive") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.memberNick = "";
        this.formList.pin = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.formList.receiverMobile = "";
        this.getBilletReceive();
      }
      // 参与赠送
      if (tab.name === "twelve") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.formList.pin = ""
        this.formList.memberNick = ""
        this.formList.sellerLinkId = ""
        this.formList.taskType = ""
        this.formList.startTime = ""
        this.formList.endTime = ""
        this.$nextTick(() => {
          this.$refs.twelveRef.reData()
        })
        this.getGameTaskRecord();
      }
      //兑换记录
      if (tab.name === "thirteen" || tab.name === "fourteen") {
        this.formList.startTime = this.getDateStr(-30) + " 00:00:00";
        this.formList.endTime = this.getDateStr(0) + " 23:59:59";
        this.getList();
      }
      //门票支付记录
      if (tab.name === "payRecord") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.memberNick = "";
        this.formList.customerPin = "";
        this.formList.payStartTime = "";
        this.formList.payEndTime = "";
        this.getBilletDouxTen();
      }
      // 出价记录
      if (tab.name === "outRecord") {
        this.formListEleven.current = 1;
        this.formListEleven.size = 10;
        this.formListEleven.isPass = "";
        this.formListEleven.bidTimeStart = "";
        this.formListEleven.bidTimeEnd  = "";
        this.formListEleven.passTimeStart = "";
        this.formListEleven.passTimeEnd = "";
        this.formListEleven.pin = "";
        this.formListEleven.memberNick = "";
        this.getBilletDouxEleven();
      }
      // 成交记录
      if (tab.name === "dealRecord") {
        this.formListTwelve.current = 1;
        this.formListTwelve.size = 10;
        this.formListTwelve.memberNick = "";
        this.formListTwelve.pin = "";
        this.formListTwelve.passTimeStart = "";
        this.formListTwelve.passTimeEnd = "";
        this.formListTwelve.payTimeStart = "";
        this.formListTwelve.payTimeEnd = "";
        this.formListTwelve.payStatus = "";
        this.getBilletDouxTwelve();
      }
      // 加购记录
      if (tab.name == "thirtyFour") {
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.addCartpage();
      }
      // 锁权记录
      if (tab.name == "eighteen") {
        // this.formList.createTimeStart = ""
        // this.formList.createTimeEnd = ""
        this.lockRightRecord();
      }
      // 积分锁权 中奖记录
      if (tab.name === "sixteen") {
        this.formList.pin = ""
        this.formList.mobile = ""
        this.formList.memberLevel = ""
        this.formList.sellerLinkId = ""
        this.formList.sendStatus = ""
        this.formList.deliveryStatus = ""
        this.formList.createTimeStart = "";
        this.formList.createTimeEnd = "";
        this.formList.sendTimeStart = "";
        this.formList.sendTimeEnd = "";
        this.formList.deliveryTimeStart = "";
        this.formList.deliveryTimeEnd = "";
        this.formList.prizeIds = "";
        this.formList.winNumMinLimit = ""
        this.formList.winNumMaxLimit = ""
        this.winningRecord();
      }
      // 积分锁权 收货信息 派样回购
      if (tab.name === "seventeen") {
        this.takeGoodsRecord();
      }
      // 打榜有礼领奖记录
      if (tab.name === "twenty-one") {
        this.formList.status = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.formList.sendTimeStart = "";
        this.formList.sendTimeEnd = "";
        this.formList.deliveryTimeStart = "";
        this.formList.deliveryTimeEnd = "";
        this.formList.winNumMinLimit = "";
        this.formList.winNumMaxLimit = "";
        this.getWinRecord();
      }
      if (tab.name === "twenty-two") {
        this.formExtra.current = 1;
        this.formExtra.size = 10;
        this.formExtra.pin = "";
        this.formExtra.memberNick = "";
        this.formExtra.prizeType = "";
        this.formExtra.prizeIds = "";
        this.formExtra.status = "";
        this.formExtra.winTimeStart = "";
        this.formExtra.winTimeEnd = "";
        this.formExtra.prizeObjectType = 1;
        this.formExtra.prizeName = "";
        this.formExtra.winNumMinLimit = "";
        this.formExtra.winNumMaxLimit = "";
        this.getWinRecord();
      }
      // 打榜有礼实物奖品名单
      if (tab.name === "twenty") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.sendTimeStart = "";
        this.formList.sendTimeEnd = "";
        this.formList.deliveryTimeStart = "";
        this.formList.deliveryTimeEnd = "";
        this.formList.commitAddressFlag = "";
        if (this.rowData.activityType == 39) {
          this.formList.status = "";
        } else {
          this.formList.prizeStatus = "";
        }
        this.getGoodsRecord();
      } else {
        delete this.formList.prizeIds
      }
      //参与用户卡片详情
      if (tab.name === "twenty16") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.getGoodsRecordOne();
      }
      //获取抽卡机会记录
      if (tab.name === "twenty13") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.opportunitiesList();
      }
      if (tab.name === "funGame") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.formList.endTime = "";
        this.formList.sellerLinkId = "";
        this.formList.taskType = "";
        this.funGameList();
        this.$refs.funGames.reData()
      }
      if(tab.name === "funGameRecord"){
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.sellerLinkId = "";
        this.formList.firstStartTime = "";
        this.formList.firstEndTime = "";
        this.formList.lastStartTime = "";
        this.formList.lastEndTime = "";
        this.joinGameRecord();
        this.$refs.funGameRecordRef.reData()
      }
      if(tab.name === "cardRecord"){
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.joinTimeStart = "";
        this.formList.joinTimeEnd = "";
        this.formList.isPass = "";
        this.inputCardList();
        this.$refs.cardRecordRef.reData()
      }
      if(tab.name === "cardInviteRecord"){
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.assistTimeStart = "";
        this.formList.assistTimeEnd = "";
        this.inputCardInviteList();
        this.$refs.cardInviteRecordRef.reData()
      }


      //组队瓜分开团记录
      if (tab.name === "twenty14") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.prizeName = "";
        this.formList.isFinish = "";
        this.formList.isWin = "";
        this.formList.createStartTime = "";
        this.formList.createEndTime = "";
        this.formList.finishStartTime = "";
        this.formList.finishEndTime = "";
        this.$refs.inputAwardTeam.reData()
        this.teamFormationList();
      }
      // 任务完成记录
      if (tab.name === "twenty100") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.taskType = "";
        this.formList.finishStartTime = "";
        this.formList.finishEndTime = "";
        if (this.rowData.activityType == 65) {
          this.taskCompletion=this.taskCompletion.filter((item) => item.label != '任务归属：')
        } else{
           this.formList.type = "";
        }
        this.$refs.inputAwardTask.reData()
        this.getTaskCompletion();
      }
      // 组队瓜分被邀请人明细
      if (tab.name === "inviteesDetail") {
        // 检查是否有标记表示是从开团记录跳转过来的
        // 如果没有标记或者标记为false，则清空表单
        if (!this.fromTeamRecord) {
          this.formList.current = 1;
          this.formList.size = 10;
          this.formList.pinOrNick = "";
          this.formList.invitePinOrNick = "";
          this.formList.teamName = "";
          this.formList.createStartTime = "";
          this.formList.createEndTime = "";
          this.$refs.inputAwardTeamInvitees.reData()
        }
        // 无论是否清空表单，都执行查询
        this.toGetInviteDetailOne();
        // 重置标记，避免影响后续的tab切换
        this.fromTeamRecord = false;
      }

      //获取抽卡记录
      if (tab.name === "twenty12") {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = "";
        this.formList.memberNick = "";
        this.formList.startTime = "";
        this.formList.endTime = "";
        this.formList.cardId = ''
        this.gachaRecords();
      }
      // 派样下单记录
      if (tab.name === "sendReBuyPay") {
        this.formList.pin = "";
        this.formList.skuId = "";
        this.formList.skuName = "";
        this.formList.orderId = "";
        this.formList.isCommitAddress = null;
        this.formList.orderTimeStart = "";
        this.formList.orderTimeEnd = "";
        this.formList.receiveTimeStart = "";
        this.formList.receiveTimeEnd = "";
        this.getSendBuyPayData();
      }
      // 回购下单记录
      if (tab.name === "sendReBuyRePay") {
        this.formList.pin = "";
        this.formList.skuId = "";
        this.formList.skuName = "";
        this.formList.orderId = "";
        this.formList.orderPaymentStart = "";
        this.formList.orderPaymentEnd = "";
        this.formList.isWin = null;
        this.formList.isCommitAddress = null;
        this.formList.orderTimeStart = "";
        this.formList.orderTimeEnd = "";
        this.formList.receiveTimeStart = "";
        this.formList.receiveTimeEnd = "";
        this.getSendBuyRePayData();
      }
      // 领取记录
      if (tab.name == "getRecord") {
        this.formListRecord = {
          size: 10,
          current: 1,
          activityId: this.rowData.id,
        };
        this.getRecord();
      }
      // 订单明细
      if (tab.name == "orderDetail") {
        this.orderDetailInfoPage = {
          size: 10,
          current: 1,
        };
        this.orderDetaiInfolForm ={
          pin: "",
          orderId: "",
          orderState: "",
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
          sellerLinkId: "",
          orderVenderId: "",
          memberNick: "",
          activityId: this.rowData.id,
        }
        this.$refs.orderDetailOverviewRef1.getDataOverview({...this.orderDetailInfoPage,...this.orderDetaiInfolForm});
        this.getOrderDetail();
        // this.$refs.orderDetailRef.reData();
        // this.searchOrderDetail({});
      }
      // 入会用户转化分析
      if (tab.name == "conversionAnalysis") {
        this.conversionPage = {
          size: 10,
          current: 1,
          total: 0,
        };
        this.searchConversion({
          openCardStartTime: this.getDateStr(-30) + " 00:00:00",
          openCardEndTime: this.getDateStr(0) + " 23:59:59"
        });
      }

      // 晒单有礼-用户资料
      if (tab.name == "thirty-one") {
        console.log("用户资料");
        console.log("formList", this.formList);
        let res = await getActivityRuleFields(this.formList.activityId);
        console.log(res);
        this.postRuleFieldsList = res.data.infoNames;
        this.isShowAuditResult = res.data.isShowAuditResult;
        if (res.data.showAllStaticField) {
          this.postRuleFieldsList = [
            "姓名",
            "订单号",
            "评价截图",
            "手机号",
            "地区",
            "详细地址",
          ];
        }
        if (res.data.showExtendInfo) {
          this.postRuleFieldsList.push("扩展信息");
        }
        if(res.data.staticInfoNames && res.data.staticInfoNames.length >0 ){
          this.staticInfoNamesInfo = res.data.staticInfoNames;
          this.expendFields= { staticInfoNames: this.staticInfoNamesInfo }
        }else {
          this.staticInfoNamesInfo = []
        }

        this._getUserProfileList();
      }
      /** 满额有礼 */
      switch (tab.name) {
        case "fullGiftJoin": // 参与记录
          this.formList.sellerLinkId = "";
          this.$refs.joinRecordRef.getList();
          break;
        case "fullGiftAward": // 领奖记录
          this.$refs.awardRecordRef.getList();
          break;
        case "fullGiftPhy": // 实物奖品名单
          this.$refs.physicalAwardRef.getList();
          break;
        case "fullGiftOrder": // 订单明细
          this.$refs.orderDetailRef.searchOrderDetail();
          break;
      }
    },
    async _getUserProfileList() {
      this.loading = true;
      getUserProfileList(this.formList).then((res) => {
        this.totalPostOrderUserInfo = 0;
        this.postOrderInfoTable = [];
        if (res.code == 1) {
          let tableData = res.data.records;
          this.postOrderInfoTable = tableData;
          this.totalPostOrderUserInfo = Number(res.data.total);
          this.formList.current = Number(res.data.current);
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });

      //汇总
      let staticRes = await getUserProfileStatic({
        activityId: this.formList.activityId,
      });
      if (staticRes.code == 1) {
        this.postUserStaticsInfo = staticRes.data || {};
      }
    },

    // 晒单有礼-用户资料查询
    searchPostUserInfo(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList = {
        ...this.formList,
        ...val,
      };
      this._getUserProfileList();
    },

    timeChange(type, index) {
      this.queryForm.evaluateTime = type;
      this.defaultIndex = index;
      if (type == null) {
        let time = this.$getActDate(7, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
      } else if (type == 7) {
        let time = this.$getActDate(7, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
      } else if (type == 15) {
        let time = this.$getActDate(15, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
      } else if (type == 30) {
        let time = this.$getActDate(30, this.rowData.startTime);
        this.postForm.startDate = time[0].substring(0, 10) + " 00:00:00";
        this.postForm.endDate = time[1].substring(0, 10) + " 23:59:59";
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    // 查询按钮
    querySeach() {
      this.formList.current = 1;
      this.formList.size = 10;
      this.queryTotal();
      this.getShopGiftParticipateConver();
    },
    //查询数据总和
    async queryTotal() {
      let tt = "00:00:00",
        start = "",
        end = "",
        startTime = "",
        endTime = "",
        tt1 = "23:59:59";
      if (this.queryForm.evaluateTime == 0) {
        if (this.postForm.startDate == "" || this.postForm.endDate == "") {
          this.$message({
            message: "自定义时间不能为空！",
            type: "warning",
          });
          return;
        }
        start = `${this.postForm.startDate} ${tt}`;
        end = `${this.postForm.endDate} ${tt1}`;
      }
      if (this.queryForm.evaluateTime == 0) {
        startTime = start;
        endTime = end;
      } else {
        startTime = this.postForm.startDate;
        endTime = this.postForm.endDate;
      }
      // 试用回购礼-活动统计(需要单独调接口)
      if(this.fitersChooseIF([52])) {
        // 获取数据汇总
        getTrialRebuyData({
          activityId: this.formList.activityId,
          startTime,
          endTime,
        }).then((res) => {
          this.loading = false;
          // 数据总览数据
          if (res.code == 200 || res.code == 1) {
            this.tableTotal = res.data;
          } else {
            this.$message.error(res.message)
          }
        })
        // 获取数据明细
        trialRebuyRecord({
          activityId: this.formList.activityId,
          startTime,
          endTime,
          size: 99999,
          current: 1,
        }).then((res) => {
            // 折线图数据
          this.chartEffectDetail = res.data.records;
          this.$nextTick(() => {
          this.initChart();
          window.addEventListener("resize", () => {
              this.myCharts.resize();
            });
          });
        })
        return;
      }
      // 获取数据汇总-通用
      getCouponData({
        activityId: this.formList.activityId,
        startTime,
        endTime,
        source: this.fitersChooseIF([9, 10, 29, 30, 38,55,58,59,60,61]) ? 2 : 1,
        sellerLinkId: this.queryForm.sellerLinkId,
      }).then((res) => {
        this.loading = false;
        // 数据总览数据
        this.tableTotal = res.data;
      });
      // 获取数据明细
      checkRecord({
        activityId: this.formList.activityId,
        startTime,
        endTime,
        source: this.fitersChooseIF([9, 10, 29, 30, 38,55,58,59,60,61]) ? 2 : 1,
        sellerLinkId:  this.queryForm.sellerLinkId,
      }).then((res) => {
        // 折线图数据
        this.chartEffectDetail = res.data;
        this.$nextTick(() => {
          this.initChart();
          window.addEventListener("resize", () => {
            this.myCharts.resize();
          });
        });
      });
    },
    //折线图
    initChart() {
      if (this.rowData.activityType != 15) {
        if (!this.myCharts) {
          this.myCharts = echarts.init(this.$refs.payRemindChart);
        } else {
          this.myCharts.clear();
        }
        this.setOptions();
      }
    },
    //折线图事件
    setOptions() {
      let lineData =  this.dataSummary
      // 试用购礼单独设置
      if(this.fitersChooseIF([52])) {
        lineData = this.trialRebuySummary;
      }
      const seriesList = lineData.map((item) => {
        return {
          name: item.name,
          type: "line",
          smooth: true,
          color: item.color,
          // 无数据显示0处理
          data: this.chartEffectDetail.map((i) =>
            i[item.value] ? i[item.value] : 0
          ),
        };
      });
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            return this.echartIcon(params);
          },
        },
        legend: {
          data: lineData.map((item) => item.name),
          bottom: -5,
          left: "center",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: this.fitersChooseIF([37,52]) ? "16%" : "11%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.fitersChooseIF([35, 37,52])
            ? this.chartEffectDetail.map((item) => item.statsDate)
            : this.chartEffectDetail.map((item) => item.dateTime),
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: seriesList,
      };

      this.myCharts.setOption(option);
    },
    // 销售打榜-榜单实况
    salesRankSummarys() {
      this.loading = true;
      let params = {
        activityId: this.formList.activityId,
      }
      salesRankSummary(params)
        .then((res) => {
          this.loading = false;
          this.salesRankSummaryTable = res.data;
        })
        .catch((res) => {});
    },
    //重置
    queryOne() {
      this.defaultIndex = 0;
      this.formList.current = 1;
      this.formList.size = 10;
      this.queryForm.evaluateTime = "7";
      this.queryForm.channelCode = "";
      this.queryForm.sellerLinkId = "";
      this.$refs.statiscFormRef.reData()
      this.timeChange(7);
      this.queryTotal();
    },
    // 参与记录
    getParticipation() {
      this.loading = true;
      participation(this.formList)
        .then((res) => {
          this.loading = false;
          this.ParticipatTable = res.data.records;
          this.totalParticipat = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 参与记录-积分锁权
    getParticipationLock() {
      this.loading = true;
      lockRecordPage(this.formListLock)
        .then((res) => {
          this.loading = false;
          this.ParticipatLockTable = res.data.records;
          this.totalParticipatLock = Number(res.data.total);
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //试用复购-参与记录
    getParticipationLockTrial() {
          this.loading = true;
          trialRebuyConfig(this.formListLockTrial)
            .then((res) => {
              this.loading = false;
              this.ParticipatLockTableTrial = res.data.records;
              this.totalParticipatLockTrial = Number(res.data.total);
            })
            .catch((res) => {
              this.loading = false;
            });
    },
    // 打包一口价
    getParticipationLockFixedPrice() {
          this.loading = true;
          participationFixedPrice(this.formList)
            .then((res) => {
              this.loading = false;
              this.ParticipatLockTableFixedPrice = res.data.records;
              this.totalParticipatLockFixedPrice = Number(res.data.total);
            })
            .catch((res) => {
              this.loading = false;
            });
    },
    // 试用复购-订单明细
    getParticipationLockTrialOrder(type) {
      this.loading = true;
      this.formListLockOrder.orderState = this.formListLockOrder.orderStateList&&this.formListLockOrder.orderStateList.length ? this.formListLockOrder.orderStateList.join(",") : ""
      let params = {
        current: this.formListLockOrder.current,
        size: this.formListLockOrder.size,
        pin: this.formListLockOrder.pin,
        orderState: this.formListLockOrder.orderState,
        orderEndTime: this.formListLockOrder.orderEndTime,
        orderStartTime: this.formListLockOrder.orderStartTime,
        memberNick: this.formListLockOrder.memberNick,
        orderType: type,
        orderId: this.formListLockOrder.orderId,
        activityId: this.formListLockOrder.activityId,
        sellerLinkId: this.formListLockOrder.sellerLinkId,
      }
      if(type==0) {
        this.$refs.orderDetailOverviewRef3 && this.$refs.orderDetailOverviewRef3.getDataOverview(params);
      } else {
        this.$refs.orderDetailOverviewRef4 && this.$refs.orderDetailOverviewRef4.getDataOverview(params);
      }
      const newParams  = {
        ...params,
        orderStateList: this.formListLockOrder.orderStateList,
      }
      delete newParams.orderState
   
      trialRebuyConfigOrder(newParams)
        .then((res) => {
          this.loading = false;
          this.ParticipatLockTableTrialOrder = res.data.records;
          this.totalParticipatLockOrder = Number(res.data.total);
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //粉丝
    getParticipationLockFans() {
          this.loading = true;
          participationPagetion(this.formListLockFans)
            .then((res) => {
              this.loading = false;
              this.ParticipatLockTableFans = res.data.records;
              this.totalParticipatLockFans = Number(res.data.total);
            })
            .catch((res) => {
              this.loading = false;
        });
    },
    //入会有礼
    getParticipationLockGift() {
          this.loading = true;
          joinRecordGift(this.formListLockFans)
            .then((res) => {
              this.loading = false;
              this.ParticipatLockTableGift = res.data.records;
              this.totalParticipatLockGift = Number(res.data.total);
            })
            .catch((res) => {
              this.loading = false;
        });
    },
    //销售打榜-榜单实况
    ranks() {
      this.loading = true;
      let params = {
        activityId: this.formList.activityId,   
      }
      rank(params)
        .then((res) => {
          this.loading = false;
          let req = []
        const list =  res.data.map((item,index) => {
          item.id = index+ ""
            req.push(rankDetail({...params, skuIdList: item.skuIdList})
           .then((n) => {
              this.loading = false;
              item.children = n.data.map((row)=>{
              row.id = row.skuId
              row.rank  = item.rank
              row.rankName = item.rankName
              row.skuIdList=[row.skuId]
              row.skuNameList=[row.skuName]
              return row
             }) 
             }))
             return item
          })
          Promise.all(req).then(() => {   
            this.ranksTable = list
          })
      })
    },
    // 积分锁权-订单明细
    getLocklOrderDetail() {
      this.loading = true;
      getLockOrderPage(this.formLockOrder)
        .then((res) => {
          this.loading = false;
          this.lockOrderData = res.data.records;
          this.lockOrderTotal = Number(res.data.total);
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //销售
    showOrderDetail() {
      this.loading = true;
      this.$refs.orderDetailOverviewRef2 && this.$refs.orderDetailOverviewRef2.getDataOverview(this.formListLockFans);
       if (this.fitersChooseIF([68])) {
        orderDetailPages(this.formListLockFans)
          .then((res) => {
          this.loading = false;
          this.orderDetailTable = res.data.records;
          this.totalOrderDetail = Number(res.data.total);
         })
         .catch((res) => {
           this.loading = false;
         });
        }else{
        orderDetailPage(this.formListLockFans)
          .then((res) => {
          this.loading = false;
          this.orderDetailTable = res.data.records;
          this.totalOrderDetail = Number(res.data.total);
         })
         .catch((res) => {
           this.loading = false;
         });
        }
    },
    //销售参与记录
    getRankingRecords() {
      this.loading = true;
      rankingRecords(this.formListLockFans)
        .then((res) => {
          this.loading = false;
          this.rankingRecordsTable = res.data.records;
          // 处理abilityVOList数据，确保相同rankName的列只显示一次
          // 1. 收集所有唯一的rankName
          const rankNames = new Set();
          res.data.records.forEach(record => {
            if (record.abilityVOList && Array.isArray(record.abilityVOList)) {
              record.abilityVOList.forEach(ability => {
                if (ability && ability.rankName) {
                  rankNames.add(ability.rankName);
                }
              });
            }
          });
          
          // 2. 构建列定义，为每个唯一rankName创建一个列
          this.abilityVOList = Array.from(rankNames).map(name => ({
            rankName: name,
            width: 160 // 默认宽度
          }));
          
          // 3. 为每条记录添加对应rankName的值映射，方便表格渲染
          res.data.records.forEach(record => {
            record.abilityValues = {};
            if (record.abilityVOList && Array.isArray(record.abilityVOList)) {
              record.abilityVOList.forEach(ability => {
                if (ability && ability.rankName) {
                  // 保存完整的能力信息，包括value和ability字段
                  record.abilityValues[ability.rankName] = {
                    ability: ability.ability
                  };
                }
              });
            }
          });
          this.totalRankingRecords = Number(res.data.total);
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //生命参与记录
    getRankingRecordsLife() {
      this.loading = true;
      userLifeRecords(this.formListLockFans)
        .then((res) => {
          this.loading = false;
          this.totalLifeRecords = 0;
          this.goodsRecordTableCardLife = [];
          let tableDataList = res.data.records
          // 同时赋值给goodsRecordTableCard，保留完整的数据结构
          this.goodsRecordTableCardLife = tableDataList.map(item => ({
            memberNick: item.memberNick || '',
            chaosPin: item.chaosPin || '',
            joinTime:item.joinTime || '',
            stages: item.stages || [],
          }));
          this.totalLifeRecords = Number(res.data.total);   
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    // 参与记录(会员升级礼)
    getMemberUpGrade() {
      this.loading = true;
      memberUpGrade(this.formList)
        .then((res) => {
          this.loading = false;
          this.MemberUpGradeTable = res.data.records;
          this.totalMemberUpGrade = Number(res.data.total);
        })
        .catch((res) => {});
    },
    getZeroTrial() {
      this.formZeroList.venderId = this.rowData.venderId;
      this.loading = true;
      const params = {...this.formZeroList};
      delete params.checkedList;
      getTrialActivityRecord(params)
        .then((res) => {
          this.loading = false;
          this.zeroTrialTable = res.data.records;
          this.totalZeroTrial = Number(res.data.total);
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    getZeroTrialDetail() {
      this.loading = true;
      this.formZeroDetailList.venderId = this.rowData.venderId;
      getQuestionnaireRecord(this.formZeroDetailList)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.zeroTrialDetailTable = res.data.records;
            this.totalZeroTrial = Number(res.data.total);
            // 提取所有可能的题目类型
            const allQuestions = new Set();
            this.zeroTrialDetailTable.forEach((item) => {
              item.answerVOList.forEach((answer) => {
                allQuestions.add(answer.type);
              });
            });
            this.dynamicColumns = Array.from(allQuestions);
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //门票支付记录
    getBilletDouxTen() {
      this.loading = true;
      BilletDouxTen(this.formList)
        .then((res) => {
          this.loading = false;
          this.exchangeListTen = res.data.records;
          this.totalMailTen = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 出价记录
    getBilletDouxEleven() {
      this.loading = true;
      BilletDouxEleven(this.formListEleven)
        .then((res) => {
          this.loading = false;
          this.exchangeListEleven = res.data.records;
          this.totalMailEleven = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 成交记录
    getBilletDouxTwelve() {
      this.loading = true;
      BilletDouxTwelve(this.formListTwelve)
        .then((res) => {
          this.loading = false;
          this.exchangeListTwelve = res.data.records;
          this.totalMailTwelve = Number(res.data.total);
        })
        .catch((res) => {});
    },



    // 参与记录(情书贺卡)
    getBilletDoux() {
      this.loading = true;
      BilletDoux(this.formList)
        .then((res) => {
          this.loading = false;
          this.BilletDouxTable = res.data.records;
          this.totalBilletDoux = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 获取记录(情书贺卡)
    getBilletReceive() {
      this.loading = true;
      BilletReceive(this.formList)
        .then((res) => {
          this.loading = false;
          this.BilletReceiveTable = res.data.records;
          this.totalBilletReceive = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 参与记录-定时开奖
    getParticipationOpenWin() {
      this.loading = true;
      joinRecordPage(this.formOpenWin)
        .then((res) => {
          this.loading = false;
          this.ParticipatOpenWinTable = res.data.records;
          this.totalParticipatOpenWin = Number(res.data.total);
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    // 幸运值获取记录-定时开奖
    getLuckList() {
      this.loading = true;
      const query = {
        current: this.formLuck.current,
        size: this.formLuck.size,
        activityId: this.formLuck.activityId,
      };
      if (this.formLuck.createStartTime) {
        query.createStartTime = this.formLuck.createStartTime;
      }
      if (this.formLuck.createEndTime) {
        query.createEndTime = this.formLuck.createEndTime;
      }
      if (this.formLuck.memberNick) {
        query.memberNick = this.formLuck.memberNick;
      }
      if (this.formLuck.pin) {
        query.pin = this.formLuck.pin;
      }
      if (this.formLuck.taskType) {
        query.taskType = this.formLuck.taskType;
      }
      if (this.formLuck.sellerLinkId) {
        query.sellerLinkId = this.formLuck.sellerLinkId;
      }
      getLuckValueRecord(query)
        .then((res) => {
          this.loading = false;
          this.luckTable = res.data.records;
          this.totalLuck = Number(res.data.total);
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //幸运值获取记录-定时开奖导出
    exportLuckValue() {
      const query = {
        activityId: this.formLuck.activityId,
      };
      if (this.formLuck.createStartTime) {
        query.createStartTime = this.formLuck.createStartTime;
      }
      if (this.formLuck.createEndTime) {
        query.createEndTime = this.formLuck.createEndTime;
      }
      if (this.formLuck.memberNick) {
        query.memberNick = this.formLuck.memberNick;
      }
      if (this.formLuck.pin) {
        query.pin = this.formLuck.pin;
      }
      if (this.formLuck.taskType) {
        query.taskType = this.formLuck.taskType;
      }
      query.current = this.formLuck.current,
      query.size = this.formLuck.size,
      exportLuckValue(query)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("导出成功");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
    },
    //参与赠送
    getGameTaskRecord() {
      this.loading = true;
      const params = {
        current: this.formList.current,
        size: this.formList.size,
        activityId: this.formList.activityId||"",
        memberNick: this.formList.memberNick||"",
        pin: this.formList.pin||"",
        sellerLinkId: this.formList.sellerLinkId||"",
        taskType: this.formList.taskType||"",
        startTime: this.formList.startTime||"",
        endTime: this.formList.endTime||"",
      }
      if(this.rowData.activityType==81) {
        params.memberLevel = this.formList.memberLevel;
      }
      gameTaskRecord(params)
        .then((res) => {
          this.loading = false;
          this.GiftrecordList = res.data.records;
          this.totalGiftrecord = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 抽奖机会赠送 查看详情
    commentDetails(item) {
      this.commentItem = item;
      this.commentDioag = true;
    },
    dialogClose() {
      this.commentDioag = false;
    },
    // 团队详情 查看详情
    async viewDetails(item) {
      if (this.fitersChooseIF([31])) {
        const { data: res } = await groupMember(item.id);
        this.CouponMember = res.map((item, i) => {
          return {
            ...item,
            // group: i == 0 ? "团长" : "团员",
          };
        });
      } else {
        const { data: res } = await CouponDetailmember(item.id);
        this.CouponMember = res.map((item, i) => {
          return {
            ...item,
            group: i == 0 ? "团长" : "团员",
          };
        });
      }
      this.dialogGroup = true;
    },
    //签到记录
    checkRecord() {
      this.loading = true;
        console.log(this.formList,'554455445545454');
      checkList(this.formList)
        .then((res) => {
          this.loading = false;
          this.signInTable = res.data.records;
          this.totalSignIn = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 补签卡获取记录
    checkRecordBu() {
      this.loading = true;
      const params = {
        current: this.formList.current,
        size: this.formList.size,
        memberNick: this.formList.memberNick||"",
        pin: this.formList.pin||"",
        sellerLinkId: this.formList.sellerLinkId||"",
        taskType: this.formList.taskType||"",
        startTime: this.formList.startTime||"",
        endTime: this.formList.endTime||"",
        activityId: this.formList.activityId,
      }
      checkListBu(params)
        .then((res) => {
          this.loading = false;
          this.signInTableSupplementary = res.data.records;
          this.totalSignInSupplementary = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 加购记录
    addCartpage() {
      this.loading = true;
      addCartpage(this.formList)
        .then((res) => {
          this.loading = false;
          this.addCartTable = res.data.records;
          this.totalAddCart = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 锁权记录
    lockRightRecord() {
      this.loading = true;
      lockRightRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.lockRightTable = res.data.records;
          this.totalLockRight = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //试用礼
    trailLin(){
        this.loading = true;
        this.searchCond = this.formListTras
        this.getTrialActivityRebuyWinRecordWinUserCount(this.formListTras)
        trialLins(this.formListTras).then((res)=>{
          this.loading = false
          this.awardTableTrial = res.data.records
          this.totalAwardTs = Number(res.data.total)
        }).catch((res) => {
        });
     },
    trailLinOne(){
      this.loading = true;
      this.searchCond = this.formListTrasOne
      this.getTrialActivityRebuyWinRecordWinUserCount(this.formListTrasOne)
      trialLins(this.formListTrasOne).then((res)=>{
        this.loading = false
        this.awardTableTrialOne = res.data.records
        this.totalAwardTsOne = Number(res.data.total)
      }).catch((res) => {
      });
   },
    // 收货信息
    takeGoodsRecord() {
      this.loading = true;
      let params = {
        ...this.formList,
        isReceiveInfo: true,
      };
      if (this.fitersChooseIF([37])) {
        params.subType = "37";
      }
      //isReceiveInfo 是否为收货信息 true收货信息 空或不传为 积分锁权-中奖记录
      lockWinRecord(params)
        .then((res) => {
          this.loading = false;
          this.takeGoodsTable = res.data.records;
          this.totalTakeGoods = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //中奖记录
    winningRecord() {
      this.loading = true;
      this.searchCond = this.formList
      // 只有邀请类的调awardRecNew接口
      this.getWinPeoples(this.formList)
      if (this.rowData.activityType == 6) {
        awardRecNew(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => {});
      } else if (this.rowData.activityType == 5) {
        //Note---邀请开卡有礼中奖纪录接口修改
        awardRecNewOne(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => {});
      } else if (this.rowData.activityType == 33) {
        this.formList.subType = 33;
        getGoodRecords(this.formList).then((res) => {
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        });
      } else if (this.rowData.activityType == 35) {
        // 积分锁权 中奖记录
        lockWinRecord(this.formList).then((res) => {
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        });
      } else if (this.rowData.activityType == 37) {
        let params = {
          subType: "37",
          ...this.formList,
        };
        // 派样回购礼
        lockWinRecord(params).then((res) => {
          this.loading = false;
          this.awardTable = res.data.records;
          this.totalAward = Number(res.data.total);
        });
      } else if (this.rowData.activityType == 46) {
        // 满额有礼 领奖记录
        this.$refs.awardRecordRef.getList();
      } else {
        awardRecord(this.formList)
          .then((res) => {
            this.loading = false;
            this.awardTable = res.data.records;
            this.totalAward = Number(res.data.total);
          })
          .catch((res) => {});
      }
    },
    //发放记录 为中奖记录的接口awardRecord
    distributionRecord() {
      this.loading = true;
      // awardRecNew(this.formList)
      awardRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.distributionTable = res.data.records;
          this.totalDistribution = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //导出
    exportTheData(exportRemark) {
      var formDate = JSON.parse(sessionStorage.getItem("exportForm"));
      if (this.rowData.activityType == 6) {
        let param = this.formList.activityId;
        const params = {
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          endTime: formDate.endTime ? formDate.endTime : "",
          startTime: formDate.startTime ? formDate.startTime : "",
          prizeType: formDate.prizeType ? formDate.prizeType : "",
          status: formDate.status ? formDate.status : "",
          memberNick: formDate.memberNick ? formDate.memberNick : "",
          orderState: formDate.orderState ? formDate.orderState : "",
          unlockOrderId: formDate.unlockOrderId ? formDate.unlockOrderId : "",
          pin: formDate.pin ? formDate.pin : "",
          exportRemark,
        };
        exportRecNew(params).then((res) => {
          if (res.code == 1) {
            this.control1 = true;
          } else {
            this.$message.error(res.message);
          }
        });
      } else if (this.rowData.activityType == 5) {
        let param = this.formList.activityId;
        const params = {
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          endTime: formDate.endTime ? formDate.endTime : "",
          startTime: formDate.startTime ? formDate.startTime : "",
          prizeType: formDate.prizeType ? formDate.prizeType : "",
          status: formDate.status ? formDate.status : "",
          memberNick: formDate.memberNick ? formDate.memberNick : "",
          orderState: formDate.orderState ? formDate.orderState : "",
          unlockOrderId: formDate.unlockOrderId ? formDate.unlockOrderId : "",
          pin: formDate.pin ? formDate.pin : "",
          exportRemark,
        };
        exportInviteCardAwardRecord(params).then((res) => {
          if (res.code == 1) {
            this.control1 = true;
          } else {
            this.$message.error(res.message);
          }
        });
      } else if (
        this.rowData.activityType == 16 ||
        this.rowData.activityType == 17 ||
        this.rowData.activityType == 18 ||
        this.rowData.activityType == 19
      ) {
        let param = this.formList.activityId;
        const params = {
          activityId: encodeURI(param),
          current: formDate.current,
          size: formDate.size,
          endTime: formDate.endTime ? formDate.endTime : "",
          startTime: formDate.startTime ? formDate.startTime : "",
          prizeType: formDate.prizeType ? formDate.prizeType : "",
          status: formDate.status ? formDate.status : "",
          memberNick: formDate.memberNick ? formDate.memberNick : "",
          orderState: formDate.orderState ? formDate.orderState : "",
          unlockOrderId: formDate.unlockOrderId ? formDate.unlockOrderId : "",
          pin: formDate.pin ? formDate.pin : "",
          exportRemark,
        };
        // 下单抽奖-添加白名单字段
        if (this.rowData.activityType == 19) {
          params.isWhite = formDate.isWhite;
        }
        exportAwardRecord(params).then((res) => {
          if (res.code == 1) {
            this.control1 = true;
          } else {
            this.$message.error(res.message);
          }
        });
      } else if (this.rowData.activityType == 33) {
        let param = this.formList.activityId;
        let elem = document.createElement("a");
        elem.style.display = "none";
        let url = `/jd-hd-web/PointActivityEffectDetails/exportGoodRecords?activityId=${encodeURI(
          param
        )}&current=${formDate.current}&size=${formDate.size}&endTime=${
          formDate.endTime ? formDate.endTime : ""
        }&startTime=${formDate.startTime ? formDate.startTime : ""}&prizeType=${
          formDate.prizeType ? formDate.prizeType : ""
        }&status=${formDate.status ? formDate.status : ""}&memberNick=${
          formDate.memberNick ? formDate.memberNick : ""
        }&orderState=${
          formDate.orderState ? formDate.orderState : ""
        }&unlockOrderId=${
          formDate.unlockOrderId ? formDate.unlockOrderId : ""
        }&pin=${formDate.pin ? formDate.pin : ""}`;
        elem.href = url;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      } else if (this.rowData.activityType == 39) {
        let param = this.rowData.id;
        let params = {
          activityId: encodeURI(param),
          current: this.formListRecord.current,
          size: this.formListRecord.size,
          endTime: this.formListRecord.endTime ? this.formListRecord.endTime : "",
          startTime: this.formListRecord.startTime
            ? this.formListRecord.startTime
            : "",
          prizeType: this.formListRecord.prizeType ? this.formListRecord.prizeType : "",
          status: this.formListRecord.status ? this.formListRecord.status : "",
          memberNick: this.formListRecord.memberNick
            ? this.formListRecord.memberNick
            : "",
          pin: this.formListRecord.pin ? this.formListRecord.pin : "",
          exportRemark,
        };
        exportPointActivityPrizeDetailBlob(params).then((res) => {
          if (res.code == 1) {
            this.$message.success(res.message);
          } else {
            this.$message.warning(res.message);
          }
        });
      } else if (this.rowData.activityType == 41) {
        //晒单有礼
        let params = {
          activityId: this.rowData.id,
          exportRemark,
          ...formDate,
        };
        exportPrizeDetail(params).then((res) => {
          if (res.code == 1) {
            this.control1 = true;
          } else {
            this.$message.warning(res.message);
          }
        });
      } else if (
        this.rowData.activityType == 45 &&
        this.tabName == "lockJoinRecord"
      ) {
        // 积分锁权-参与记录
        let params = {
          activityId: this.rowData.id,
          exportRemark,
          ...this.formListLock,
        };
        lockRecordExport(params).then((res) => {
          if (res.code == 1) {
            this.control1 = true;
          } else {
            this.$message.warning(res.message);
          }
        });
      } else if (
        this.rowData.activityType == 48 &&
        this.tabName == "openWinRecord"
      ) {
        // 定时开奖-参与记录
        let params = {
          activityId: this.rowData.id,
          exportRemark,
          ...this.formOpenWin,
        };
        joinRecordExport(params).then((res) => {
          if (res.code == 1) {
            this.control1 = true;
          } else {
            this.$message.warning(res.message);
          }
        });
      } else {
        let param = this.formList.activityId;
        let formDateNew = formDate || this.formList;
        const params = {
          activityId: encodeURI(param),
          current: formDateNew.current,
          size: formDateNew.size,
          endTime: formDateNew.endTime ? formDateNew.endTime : "",
          startTime: formDateNew.startTime ? formDateNew.startTime : "",
          prizeType: formDateNew.prizeType ? formDateNew.prizeType : "",
          status: formDateNew.status ? formDateNew.status : "",
          memberNick: formDateNew.memberNick ? formDateNew.memberNick : "",
          orderState: formDateNew.orderState ? formDateNew.orderState : "",
          unlockOrderId: formDateNew.unlockOrderId ? formDateNew.unlockOrderId : "",
          pin: formDateNew.pin ? formDateNew.pin : "",
          exportRemark,
          prizeIds: formDateNew.prizeIds ? formDateNew.prizeIds : "",
        };
        winnRecord(params).then((res) => {
          if (res.code == 1) {
            this.control1 = true;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 会员升级礼参与记录导出
    exportTheData2(exportRemark) {
      console.log("--- exportRemark:---", exportRemark);
      let param = this.formList.activityId;
      const formData = this.formList;
      const params = {
        activityId: encodeURI(param),
        current: formData.current,
        size: formData.size,
        memberNick: formData.memberNick ? formData.memberNick : "",
        pin: formData.pin ? formData.pin : "",
        createStartTime: formData.createStartTime
          ? formData.createStartTime
          : "",
        createStartTime: formData.createStartTime
          ? formData.createStartTime
          : "",
        latestJoinStartTime: formData.latestJoinStartTime
          ? formData.latestJoinStartTime
          : "",
        latestJoinEndTime: formData.latestJoinEndTime
          ? formData.latestJoinEndTime
          : "",
        isUpgrades: formData.isUpgrades,
        isWin: formData.isWin,
        remark: exportRemark,
      };
      exportMemberDetail(params).then((res) => {
        if (res.code == 1) {
          this.control7 = true;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 0元试用参与记录导出
    exportZeroTrial(exportRemark) {
      let param = this.formList.activityId;
      const formData = this.formZeroList;
      const params = {
        activityId: encodeURI(param),
        venderId: this.rowData.venderId,
        current: formData.current,
        size: formData.size,
        memberNick: formData.memberNick ? formData.memberNick : "",
        pin: formData.pin ? formData.pin : "",
        prizeName: formData.prizeName ? formData.prizeName : "",
        isWin: formData.isWin ? formData.isWin : "",
        grantStatus: formData.grantStatus ? formData.grantStatus : "",
        isAddress: formData.isAddress ? formData.isAddress : "",
        joinStartTime: formData.joinStartTime ? formData.joinStartTime : "",
        joinEndTime: formData.joinEndTime ? formData.joinEndTime : "",
        grantStartTime: formData.grantStartTime ? formData.grantStartTime : "",
        grantEndTime: formData.grantEndTime ? formData.grantEndTime : "",
        exportRemark: exportRemark,
        sellerLinkId: formData.sellerLinkId ? formData.sellerLinkId : "",
        level: formData.level ? formData.level : "",
        receiverMobileList: formData.receiverMobileList ? formData.receiverMobileList : [],
        regionList: formData.regionList ? formData.regionList : [],
      };
      exportZeroTrialRecord(params).then((res) => {
        if (res.code == 1) {
          this.control0 = true;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 试用反馈详情
    exportZeroTrialDetail(exportRemark) {
      let param = this.formList.activityId;
      const formData = this.formZeroDetailList;
      const params = {
        activityId: encodeURI(param),
        current: formData.current,
        size: formData.size,
        memberNick: formData.memberNick ? formData.memberNick : "",
        pin: formData.pin ? formData.pin : "",
        prizeName: formData.prizeName ? formData.prizeName : "",
        startTime: formData.startTime ? formData.startTime : "",
        endTime: formData.endTime ? formData.endTime : "",
        exportRemark: exportRemark,
      };
      exportQuestionnaireRecord(params).then((res) => {
        if (res.code == 1) {
          this.control11 = true;
        } else {
          this.$message.error(res.message);
        }
        exportQuestionnaireRecord(params).then((res) => {
          if(res.code == 1){
            this.control11 = true;
          }else{
            this.$message.error(res.message);
          }
        })
      })
    },
    exportZeroTrialDetailTiral(exportRemark) {
      let param = this.formList.activityId;
      const formData = this.formListLockTrial
        const params = {
          activityId: encodeURI(param),
          current: formData.current,
          size: formData.size,
          memberNick: formData.memberNick ? formData.memberNick : "",
          pin: formData.pin ? formData.pin : "",
          startTime: formData.startTime ? formData.startTime : "",
          endTime: formData.endTime ? formData.endTime : "",
          exportRemark: exportRemark,
          isGetFormalGift: formData.isGetFormalGift? formData.isGetFormalGift : "",
          isGetTrialGift: formData.isGetTrialGift? formData.isGetTrialGift : "",
          skuId: formData.skuId? formData.skuId : "",
          orderId: formData.orderId? formData.orderId : "",
        }
        trialRebuyExport(params).then((res) => {
          if(res.code == 1){
            this.control12 = true;
          }else{
            this.$message.error(res.message);
          }
        })
    },
    //试用礼零件记录导出
    exportZeroTrialDetailTirals(exportRemark) {
      let param = this.formList.activityId;
      const formData = this.formListTras
        const params = {
          activityId: encodeURI(param),
          current: formData.current,
          size: formData.size,
          nickName: formData.nickName ? formData.nickName : "",
          sendStatusList: formData.sendStatusList ? formData.sendStatusList : [],
          prizeType: formData.prizeType ? formData.prizeType : "",
          prizeName: formData.prizeName ? formData.prizeName : "",
          pin: formData.pin ? formData.pin : "",
          exportRemark: exportRemark,
          winStartTime: formData.winStartTime? formData.winStartTime : "",
          winEndTime: formData.winEndTime? formData.winEndTime : "",
          orderStateList: formData.orderStateList? formData.orderStateList : [],
          isWin: formData.isWin? formData.isWin : "",
          orderId: formData.orderId? formData.orderId : "",
          winType: 0,
        }
        winRecordExports(params).then((res) => {
          if(res.code == 1){
            this.control13 = true;
          }else{
            this.$message.error(res.message);
          }
        })
    },
    exportZeroTrialDetailTiralsOne(exportRemark) {
      let param = this.formList.activityId;
      const formData = this.formListTrasOne
        const params = {
          activityId: encodeURI(param),
          current: formData.current,
          size: formData.size,
          nickName: formData.nickName ? formData.nickName : "",
          pin: formData.pin ? formData.pin : "",
          sendStatusList: formData.sendStatusList ? formData.sendStatusList : [],
          prizeType: formData.prizeType ? formData.prizeType : "",
          prizeName: formData.prizeName ? formData.prizeName : "",
          exportRemark: exportRemark,
          winStartTime: formData.winStartTime? formData.winStartTime : "",
          winEndTime: formData.winEndTime? formData.winEndTime : "",
          orderStateList: formData.orderStateList? formData.orderStateList : [],
          isWin: formData.isWin? formData.isWin : "",
          orderId: formData.orderId? formData.orderId : "",
          winType: 1,
        }
        winRecordExports(params).then((res) => {
          if(res.code == 1){
            this.control14 = true;
          }else{
            this.$message.error(res.message);
          }
        })
    },
    // 情书贺卡导出
    exportTheData3(exportRemark) {
      if (this.billetExportType == "1") {
        // 参与记录导出
        let param = this.formList.activityId;
        const formData = this.formList;
        const params = {
          activityId: encodeURI(param),
          memberNick: formData.memberNick ? formData.memberNick : "",
          pin: formData.pin ? formData.pin : "",
          startTime: formData.startTime ? formData.startTime : "",
          endTime: formData.endTime ? formData.endTime : "",
          finishedFlag: formData.finishedFlag ? formData.finishedFlag : "",
          current: formData.current,
          size: formData.size,
          exportRemark: exportRemark,
        };
        exportBilletDetail(params).then((res) => {
          if (res.code == 1) {
            this.control9 = true;
          } else {
            this.$message.error(res.message);
          }
        });
      } else if (this.billetExportType == "2") {
        // 获取记录导出
        let param = this.formList.activityId;
        const formData = this.formList;
        const params = {
          activityId: encodeURI(param),
          memberNick: formData.memberNick ? formData.memberNick : "",
          pin: formData.pin ? formData.pin : "",
          startTime: formData.startTime ? formData.startTime : "",
          endTime: formData.endTime ? formData.endTime : "",
          receiverMobile: formData.receiverMobile
            ? formData.receiverMobile
            : "",
          current: formData.current,
          size: formData.size,
          exportRemark: exportRemark,
        };
        exportBilletReceive(params).then((res) => {
          if (res.code == 1) {
            this.control9 = true;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 数据统计导出
    exportTheDataStatic(exportRemark) {
      let activityId = this.formList.activityId;
      let params = {
        activityId: activityId,
        exportRemark: exportRemark,
        startTime: this.postForm.startDate,
        endTime: this.postForm.endDate,
        exportType: this.exportType,
        source: this.fitersChooseIF([9, 10, 29, 30, 38,55,58,59,60,61]) ? 2 : 1,
      };
      console.log("--- params:---", params);
      // 根据活动类型选择不同的导出方法
      if (this.fitersChooseIF([52])) {
        params.exportType = 0;

        if (
          params.startTime.indexOf("00:00:00") != -1 &&
          params.endTime.indexOf("23:59:59") != -1
        ) {
          params.startTime = this.postForm.startDate;
          params.endTime = this.postForm.endDate;
        } else {
          params.startTime = this.postForm.startDate + " 00:00:00";
          params.endTime = this.postForm.endDate + " 23:59:59";
        }
      
        // 活动类型52使用专用的导出方法
        exportStatisticsTrial(params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            this.control8 = true;
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        // 其他活动类型使用通用导出方法
        exportStatistics(params).then((res) => {
          if (res.code == 1 || res.code == 200) {
            this.control8 = true;
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 数据统计表格导出
    exportTableStatic(exportRemark) {
      let activityId = this.formList.activityId;
      let params = {
        activityId: activityId,
        exportRemark: exportRemark,
        startTime: this.postForm.startDate,
        endTime: this.postForm.endDate,
        exportTabName: this.tabMap[this.switchIndex],
        source: this.fitersChooseIF([9, 10, 29, 30, 38,55,58,59,60,61]) ? 2 : 1,
      };
      console.log("--- params:---", params);
      // 根据活动类型选择不同的导出方法
      const exportMethod = this.fitersChooseIF([52]) ? trialRebuyExports : exportTableStatistics;
      let startTimeArr = params.startTime.split(" ")
      let endTimeArr = params.endTime.split(" ")
      if(startTimeArr.length == 1){
        params.startTime = params.startTime + ' 00:00:00'
      }
      if(endTimeArr.length == 1){
        params.endTime = params.endTime + ' 23:59:59'
      }
      
      // 调用选择的导出方法并处理响应
      exportMethod(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 抽卡记录导出
    exportGachaRecords(exportRemark) {
      let activityId = this.formList.activityId;
      const formData = this.formList;
      let params = {
        activityId: activityId,
        cardId: formData.cardId,
        memberNick: formData.memberNick ? formData.memberNick : "",
        pin: formData.pin ? formData.pin : "",
        startTime: formData.startTime ? formData.startTime : "",
        endTime: formData.endTime ? formData.endTime : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      console.log("--- params:---", params);
      exportGachaRecords(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //开团记录导出
    exportTeamSharePrizeRecords(exportRemark) {
      let activityId = this.formList.activityId;
      const formData = this.formList;
      let params = {
        activityId: activityId,
        memberNick: formData.memberNick ? formData.memberNick : "",
        pin: formData.pin ? formData.pin : "",
        createStartTime: formData.createStartTime ? formData.createStartTime : "",
        createEndTime: formData.createEndTime ? formData.createEndTime : "",
        finishStartTime: formData.finishStartTime ? formData.finishStartTime : "",
        finishEndTime: formData.finishEndTime ? formData.finishEndTime : "",
        isWin: formData.isWin ? formData.isWin : "",
        isFinish: formData.isFinish ? formData.isFinish : "",
        prizeName: formData.prizeName ? formData.prizeName : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      exportTeamSharePrizeRecords(params)
        .then((res) => {
           if (res.code == 1 || res.code == 200) {
             this.$message.success(res.message);
           } else {
            this.$message.error(res.message);
          }
         }).catch((res) => {});
    },
    //被邀请人明细导出
    exportGachaTreeRecords(exportRemark) {
      let activityId = this.formList.activityId;
      const formData = this.formList;
      let params = {
        activityId: activityId,
        memberNick: formData.memberNick ? formData.memberNick : "",
        pin: formData.pin ? formData.pin : "",
        pinOrNick: formData.pinOrNick ? formData.pinOrNick : "",
        invitePinOrNick: formData.invitePinOrNick ? formData.invitePinOrNick : "",
        teamName: formData.teamName ? formData.teamName : "",
        startTime: formData.createStartTime ? formData.createStartTime : "",
        endTime: formData.createEndTime ? formData.createEndTime : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      exportMemberInviteDetails(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 任务完成记录导出
    exportTaskRecords(exportRemark) {
      let activityId = this.formList.activityId;
      const formData = this.formList;
      let params = {
        activityId: activityId,
        memberNick: formData.memberNick ? formData.memberNick : "",
        pin: formData.pin ? formData.pin : "",
        type: formData.type ? formData.type : "",
        taskType: formData.taskType ? formData.taskType : "",
        startTime: formData.finishStartTime ? formData.finishStartTime : formData.startTime ? formData.startTime : "",
        endTime: formData.finishEndTime ? formData.finishEndTime : formData.endTime ? formData.endTime : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      if(this.rowData.activityType == 81) {
       params.memberLevel = formData.memberLevel
      }
      exportGameTaskRecord(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //销售-订单明细
    exportRansRecords(exportRemark) {
      let activityId = this.formList.activityId;
      let id = {
        activityId:activityId,
        exportRemark: exportRemark,
      }
      rankExportDetail(id).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //销售-参与明细
    exportRansRecordsOne(exportRemark) {
       let activityId = this.formList.activityId;
       const formData = this.formListLockFans
       let params = {
        activityId: activityId,
        pin: formData.pin ? formData.pin : "",
        joinStartTime: formData.joinStartTime ? formData.joinStartTime : "",
        joinEndTime: formData.joinEndTime ? formData.joinEndTime : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      exportJoinRecords(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //生命导出
    exportRansRecordsLifes(exportRemark) {
       let activityId = this.formList.activityId;
       const formData = this.formListLockFans
       let params = {
        activityId: activityId,
        pin: formData.pin ? formData.pin : "",
        memberNick: formData.memberNick ? formData.memberNick : "",
        createStartTime: formData.createStartTime ? formData.createStartTime : "",
        createEndTime: formData.createEndTime ? formData.createEndTime : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      exportuserLife(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //门票支付记录
    exportBilletDouxTen(exportRemark) {
       let activityId = this.formList.activityId;
       const formData = this.formList
       let params = {
        activityId: activityId,
        customerPin: formData.customerPin ? formData.customerPin : "",
        memberNick: formData.memberNick ? formData.memberNick : "",
        payStartTime: formData.payStartTime ? formData.payStartTime : "",
        sellerLinkId: formData.sellerLinkId ? formData.sellerLinkId : "",
        payEndTime: formData.payEndTime ? formData.payEndTime : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      exportTicketPayRecord(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //出价记录
    exportBilletDouxEleven(exportRemark) {
       let activityId = this.formList.activityId;
       const formData = this.formListEleven
       let params = {
        activityId: activityId,
        isPass: formData.isPass ? formData.isPass : "",
        bidTimeStart: formData.bidTimeStart ? formData.bidTimeStart : "",
        bidTimeEnd: formData.bidTimeEnd ? formData.bidTimeEnd : "",
        passTimeStart: formData.passTimeStart ? formData.passTimeStart : "",
        passTimeEnd: formData.passTimeEnd ? formData.passTimeEnd : "",
        pin: formData.pin ? formData.pin : "",
        sellerLinkId: formData.sellerLinkId ? formData.sellerLinkId : "",
        memberNick: formData.memberNick ? formData.memberNick : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      exportBidRecords(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //成交记录
    exportBilletDouxTwelve(exportRemark) {
       let activityId = this.formList.activityId;
       const formData = this.formListTwelve
       let params = {
        activityId: activityId,
        passTimeStart: formData.passTimeStart ? formData.passTimeStart : "",
        passTimeEnd: formData.passTimeEnd ? formData.passTimeEnd : "",
        payTimeStart: formData.payTimeStart ? formData.payTimeStart : "",
        payTimeEnd: formData.payTimeEnd ? formData.payTimeEnd : "",
        payStatus: formData.payStatus ? formData.payStatus : "",
        pin: formData.pin ? formData.pin : "",
        sellerLinkId: formData.sellerLinkId ? formData.sellerLinkId : "",
        memberNick: formData.memberNick ? formData.memberNick : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      exportDealRecords(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //粉丝发卡
    exportTaskRecordsFans(exportRemark) {
      let activityId = this.formList.activityId;
       const formData = this.formListLockFans
       let params = {
        activityId: activityId,
        memberNick: formData.memberNick ? formData.memberNick : "",
        pin: formData.pin ? formData.pin : "",
        sellerLinkId: formData.sellerLinkId ? formData.sellerLinkId : "",
        isPass: formData.isPass ? formData.isPass : "",
        isWin: formData.isWin ? formData.isWin : "",
        createEndTime: formData.createEndTime ? formData.createEndTime : "",
        createStartTime: formData.createStartTime ? formData.createStartTime : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      fansExport(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //入会有礼导出
    exportGiftRecords(exportRemark) {
      let activityId = this.formList.activityId;
       const formData = this.formListLockFans
       let params = {
        activityId: activityId,
        memberNick: formData.memberNick ? formData.memberNick : "",
        pin: formData.pin ? formData.pin : "",
        sellerLinkId: formData.sellerLinkId ? formData.sellerLinkId : "",
        isPass: formData.isPass ? formData.isPass : "",
        isWin: formData.isWin ? formData.isWin : "",
        createEndTime: formData.createEndTime ? formData.createEndTime : "",
        createStartTime: formData.createStartTime ? formData.createStartTime : "",
        current: formData.current,
        size: formData.size,
        exportRemark: exportRemark,
      };
      exportMemberGift(params).then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //资料明细
    improveRecord() {
      this.loading = true;
      improveList(this.formList)
        .then((res) => {
          this.loading = false;
          this.userInfoTable = res.data.records;
          this.totalUserInfo = Number(res.data.total);
        })
        .catch((res) => {});
    },
    closeOrder() {
      this.orderFrom.sendWithOrderId = '';
      this.isShowOrder = false
    },
    orderSubmit() {
      this.$refs.orderFormRef.validate(async(valid) => {
        if (valid) {
          const res = await markSendWithOrder(this.orderFrom);
          if (res.code === 1) {
            this.$message.success('操作成功');
            this.closeOrder()
            if (this.tabName == "twenty-one") {
              // 打榜有礼的
              this.getWinRecord();
            } else {
              // 实物奖品名单不需要获取积分相关接口，暂时这样处理
              if (this.tabName != "four") {
                this.winningRecord();
              }
              this.inKingRecord();
              this.$refs.awardRecordRef && this.$refs.awardRecordRef.getList();
            }
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        } else {
          return false;
        }
      });
    },
    //标记状态
    async markIss(row,prizeType=null) {
      if(prizeType==14) {
        this.isShowOrder = true
        this.orderFrom.recordId = row.recordId || row.id
      } else {
        signIssuance({ id: row.recordId || row.id })
        .then((res) => {
          if (res && res.code == 1) {
            if (this.tabName == "twenty-one") {
              // 打榜有礼的
              this.getWinRecord();
            } else {
              // 实物奖品名单不需要获取积分相关接口，暂时这样处理
              if (this.tabName != "four") {
                this.winningRecord();
              }
              this.inKingRecord();
              this.$refs.awardRecordRef && this.$refs.awardRecordRef.getList();
            }
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
      }

    },
    // 抽奖机会赠送
    commentDraw() {
      this.loading = true;
      commentDraw(this.formList)
        .then((res) => {
          this.loading = false;
          this.CommentList = res.data.records;
          this.totalComment = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 拼券明细
    CoupondDtails() {
      this.loading = true;

      if (this.fitersChooseIF([21])) {
        getSplitCouponlist(this.formList).then((res) => {
          this.loading = false;
          this.couponDetailsList = res.data.records;
          this.totalCoupon = Number(res.data.total);
        });
      } else {
        splitCouponPage(this.formList).then((res) => {
          this.loading = false;
          this.couponDetailsList = res.data.records;
          this.totalCoupon = Number(res.data.total);
        });
      }
    },
    // 优惠券统计
    CouponStatistics() {
      this.loading = true;
      if (this.fitersChooseIF([21])) {
        getStatisticsCouponlist(this.formList).then((res) => {
          this.loading = false;
          this.CouponStatisticsList = res.data.records.map((item, index) => {
            let obj = item;
            obj.id = index + "@10";
            let num = index++;
            if (obj.data.length != 0) {
              obj.data.forEach((ele, i) => {
                ele.id = num + new Date();
              });
            }
            return obj;
          });
          this.totalCouponstatistics = Number(res.data.total);
        });
      } else {
        splitCouponStatistics(this.formList).then((res) => {
          this.loading = false;
          this.CouponStatisticsList = res.data.map((item, index) => {
            let obj = item;
            obj.id = index + "@1@";
            return obj;
          });
        });
      }
    },
    // 团队详情
    TeamDetails() {
      this.loading = true;
      if (this.fitersChooseIF([31])) {
        splitCouponGroup(this.formList).then((res) => {
          this.loading = false;
          this.TeamDetailsList = res.data.records;
          this.totalTeam = Number(res.data.total);
        });
      } else {
        CouponDetail(this.formList).then((res) => {
          this.loading = false;
          this.TeamDetailsList = res.data.records;
          this.totalTeam = Number(res.data.total);
        });
      }
    },

    /*************************分页事件 *******************/
    handleSizePostUserInfo(val) {
      this.formList.size = val;
      this._getUserProfileList();
    },
    handleCurrentPostUserInfo(val) {
      this.formList.current = val;
      this._getUserProfileList();
    },
    handlePagePostOrder(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this._getUserProfileList();
    },

    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.queryTotal();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.queryTotal();
    },
    handleCurrentChangeAll(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.queryTotal();
    },
    handlePage(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.queryTotal();
    },

    handlePageSignIn(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.checkRecord();
    },
    handlePageSignInSupplementary(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.checkRecordBu();
    },
    // 补签卡获取记录搜索
     searchFormBu(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.taskType = val.taskType;   
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.checkRecordBu();
     },
    handleSizeAddCart(val) {
      this.formList.size = val;
      this.addCartpage();
    },
    handleCurrentAddCart(val) {
      this.formList.current = val;
      this.addCartpage();
    },
    handleSizeLockRight(val) {
      this.formList.size = val;
      this.lockRightRecord();
    },
    handleCurrentLockRight(val) {
      this.formList.current = val;
      this.lockRightRecord();
    },
    handleSizeTakeGoods(val) {
      this.formList.size = val;
      this.takeGoodsRecord();
    },
    handleCurrentTakeGoods(val) {
      this.formList.current = val;
      this.takeGoodsRecord();
    },
    handleSizeTakeGoodsPages() {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.takeGoodsRecord();
    },
    // 下载模板
    downloadShowDataTemplate() {
      // 显示加载中状态
      this.loading = true;
      // 调用接口获取文件流
      userProfile({activityId:this.formList.activityId}).then(res => {
        let blob = new Blob([res.blob]);
        var link = document.createElement("a"); //a标签下载
        link.href = window.URL.createObjectURL(blob);
        link.download = "晒单资料.xls";
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(err => {
        this.$message.error('下载模板失败');
      }).finally(() => {
        // 无论成功失败都关闭加载状态
        this.loading = false;
      });
    },
    // 参与记录
    handlePageParticipat(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getParticipation();
    },
    // handleSizeParticipat(val) {
    //   this.formList.size = val;
    //   this.getParticipation();
    // },
    // handleCurrentParticipat(val) {
    //   this.formList.current = val;
    //   this.getParticipation();
    // },
    // 参与记录-积分锁权
    handleSizeParticipatLock(val) {
      this.formListLock.size = val;
      this.getParticipationLock();
    },
    handleCurrentParticipatLock(val) {
      this.formListLock.current = val;
      this.getParticipationLock();
    },
    handlePageParticipatLock(pageInfo) {
      this.formListLock.size = pageInfo.pageSize;
      this.formListLock.current = pageInfo.pageNum;
      this.getParticipationLock();
    },
    //试用复购-参与记录
    handleSizeParticipatLockTri(val) {
      this.formListLockTrial.size = val;
      this.getParticipationLockTrial();
    },
    handleCurrentParticipatLockTri(val) {
       this.formListLockTrial.current = val.pageNum;
       this.formListLockTrial.size = val.pageSize;
       this.getParticipationLockTrial();
    },
    handleCurrentParticipatLockFixedPrice(val) {
       this.formList.current = val.pageNum;
       this.formList.size = val.pageSize;
       this.getParticipationLockFixedPrice();
    },
    handleCurrentParticipatLockFans(val) {
       this.formListLockFans.current = val.pageNum;
       this.formListLockFans.size = val.pageSize;
       this.getParticipationLockFans();
    },
    handleCurrentParticipatLockGift(val) {
       this.formListLockFans.current = val.pageNum;
       this.formListLockFans.size = val.pageSize;
       this.getParticipationLockGift();
    },  
    
    handleCurrentParticipatRank(val) {
       this.formListLockFans.current = val.pageNum;
       this.formListLockFans.size = val.pageSize;
       this.showOrderDetail();
    },
    handleCurrentrank(val) {
       this.formListLockFans.current = val.pageNum;
       this.formListLockFans.size = val.pageSize;
       if(this.rowData.activityType == 68) {
          this.getRankingRecordsLife();
       } else {
         this.getRankingRecords();
       }
    },
    //试用复购-订单明细
    handleSizeParticipatLockOrder(val) {
      this.formListLockOrder.current = val.pageNum;
      this.formListLockOrder.size = val.pageSize;
      const type = {
        lockJoinRecord1: 0,
        lockJoinRecord2: 1
      }
      this.getParticipationLockTrialOrder(type[this.activeName]);
    },
    //积分锁权-订单明细
    handleSizeLockOrderDetail(val) {
      this.formLockOrder.current = val.pageNum;
      this.formLockOrder.size = val.pageSize;
      this.getLocklOrderDetail();
    },
    // 参与记录-定时开奖
    handleSizeParticipatOpenWin(val) {
      this.formOpenWin.size = val;
      this.getParticipationOpenWin();
    },
    handleCurrentParticipatOpenWin(val) {
      this.formOpenWin.current = val;
      this.getParticipationOpenWin();
    },
    handlePageParticipatOpenWin(pageInfo) {
      this.formOpenWin.size = pageInfo.pageSize;
      this.formOpenWin.current = pageInfo.pageNum;
      this.getParticipationOpenWin();
    },

    // 幸运值获取记录-定时开奖
    handleSizeLuck(val) {
      this.formLuck.size = val;
      this.getLuckList();
    },
    handleCurrentLuck(val) {
      this.formLuck.current = val;
      this.getLuckList();
    },
    handleLuck(val) {
      this.formLuck.size = val.pageSize;
      this.formLuck.current = val.pageNum;
      this.getLuckList();
    },
    // 参与记录(会员升级礼)
    handlePageMemberUpGrade(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getMemberUpGrade();
    },
    handleSizeMemberUpGrade(val) {
      this.formList.size = val;
      this.getMemberUpGrade();
    },
    handleCurrentMemberUpGrade(val) {
      this.formList.current = val;
      this.getMemberUpGrade();
    },
    // 参与记录(0元试用)
    handleSizeZeroTrial(val) {
      this.formZeroList.size = val.pageSize;
      this.formZeroList.current = val.pageNum;
      this.getZeroTrial();
    },
    handleCurrentZeroTrial(val) {
      this.formZeroList.current = val;
      this.getZeroTrial();
    },
    // 试用反馈详情(0元试用)
    handleSizeZeroTrialDetail(val) {
      this.formZeroDetailList.size = val.pageSize;
      this.formZeroDetailList.current = val.pageNum;
      this.getZeroTrialDetail();
    },
    handleCurrentZeroTrialDetail(val) {
      this.formZeroDetailList.current = val;
      this.getZeroTrialDetail();
    },
    // 参与记录(情书贺卡)
    handlePageBilletDoux(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getBilletDoux();
    },
    handleSizeBilletDoux(val) {
      this.formList.size = val;
      this.getBilletDoux();
    },
    handleCurrentBilletDoux(val) {
      this.formList.current = val;
      this.getBilletDoux();
    },
    // 获取记录(情书贺卡)
    handlePageBilletReceive(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getBilletReceive();
    },
    handleSizeBilletReceive(val) {
      this.formList.size = val;
      this.getBilletReceive();
    },
    handleCurrentBilletReceive(val) {
      this.formList.current = val;
      this.getBilletReceive();
    },
    handleSizeAward(val) {
      this.formList.size = val;
      this.winningRecord();
    },
    handlePageAwardTs(val){
      this.formListTras.size = val.pageSize;
      this.formListTras.current = val.pageNum;
      this.trailLin();
    },   
    // handleSizeAwardTs(val){
    //   this.formListTras.size = val.pageSize;
    //   this.formListTras.current = val.pageNum;
    //   this.trailLin();
    // },
    // handleCurrentAwardTs(val) {
    //   this.formListTras.current = val;
    //   this.trailLin();
    // },
    handleSizeAwardTsOne(val){
      this.formListTrasOne.size = val.pageSize;
      this.formListTrasOne.current = val.pageNum;
      this.trailLinOne();
    },
    handleCurrentAwardTsOne(val) {
      this.formListTrasOne.current = val;
      this.trailLinOne();
    },
    handleSizeAwardAll(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.winningRecord();
    },
    handleSizeAward1(val) {
      this.formList.size = val;
      this.statistics();
    },
    handleSizeAward1All(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.statistics();
    },
    handlePageAwardOne(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.distributionRecord();
    },
    handleSizeAwardOne(val) {
      this.formList.size = val;
      this.distributionRecord();
    },
    handleCurrentAward(val) {
      this.formList.current = val;
      this.winningRecord();
    },
    handleAwardTabPage(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.winningRecord();
    },
    handleCurrentAward1(val) {
      this.formList.current = val;
      this.statistics();
    },
    handleCurrentAwardOne(val) {
      this.formList.current = val;
      this.distributionRecord();
    },
    handlePageAward(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.winningRecord();
    },
    handleSizeInkind(val) {
      this.formList.size = val;
      this.inKingRecord();
    },
    handleCurrentInkind(val) {
      this.formList.current = val;
      this.inKingRecord();
    },
    handlePageInkind(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.inKingRecord();
    },
    handleSizeUserInfo(val) {
      this.formList.size = val;
      this.improveRecord();
    },
    handleCurrentUserInfo(val) {
      this.formList.current = val;
      this.improveRecord();
    },
    handleUserPage(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.improveRecord();
    },
    // 抽奖机会赠送
    handlePageComment(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.commentDraw();
    },
    handleSizeComment(val) {
      this.formList.size = val;
      this.commentDraw();
    },
    handleCurrentComment(val) {
      this.formList.current = val;
      this.commentDraw();
    },
    // 拼券明细
    handlePageCoupond(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.CoupondDtails();
    },
    handleSizeCoupond(val) {
      this.formList.size = val;
      this.CoupondDtails();
    },
    handleCurrentCoupond(val) {
      this.formList.current = val;
      this.CoupondDtails();
    },
    // 优惠券统计
    handlePageCouponStatistics(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.CouponStatistics();
    },
    handleSizeCouponStatistics(val) {
      this.formList.size = val;
      this.CouponStatistics();
    },
    handleCurrentCouponStatistics(val) {
      this.formList.current = val;
      this.CouponStatistics();
    },
    // 团队详情
    handlePageTeam(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.TeamDetails();
    },
    taskCompletionhandlePage(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getTaskCompletion();
    },
    handleSizeTeam(val) {
      this.formList.size = val;
      this.TeamDetails();
    },
    handleCurrentTeam(val) {
      this.formList.current = val;
      this.TeamDetails();
    },
    // 赠送记录
    handleSizeGiftrecord(val) {
      this.formList.size = val;
      this.getGameTaskRecord();
    },
    handleCurrentGiftrecord(val) {
      this.formList.current = val;
      this.getGameTaskRecord();
    },
    handlePageGiftrecord({ pageNum, pageSize }) {
      this.formList.size = pageSize;
      this.formList.current = pageNum;
      this.getGameTaskRecord();
    },
    //签到查询
    searchForm(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.checkRecord();
    },
    // 加购记录查询
    searchAddCart(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.isWin = val.isWin;
      this.formList.pin = val.pin;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.addCartpage();
    },
    //参与记录查询
    searchParticipationForm(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.startScore = val.startScore;
      this.formList.endScore = val.endScore;
      this.formList.isPass = val.isPass;
      this.formList.isDraw = val.isDraw;
      this.formList.isWin = val.isWin;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.pin = val.pin;
      this.getParticipation();
    },
    //积分锁权参与记录查询
    searchParticipationLockForm(val) {
      this.formListLock.current = 1;
      this.formListLock.size = 10;
      this.formListLock.memberNick = val.memberNick || "";
      this.formListLock.pin = val.pin || "";
      this.formListLock.isPass = val.isPass;
      this.formListLock.isWin = val.isWin;
      this.formListLock.createStartTime = val.createStartTime;
      this.formListLock.createEndTime = val.createEndTime;
      this.formListLock.winStartTime = val.winStartTime;
      this.formListLock.winEndTime = val.winEndTime;
      this.formListLock.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getParticipationLock();
    },
    //试用复购-参与记录
    searchParticipationLockFormTrial(val){
      this.formListLockTrial.current = 1;
      this.formListLockTrial.size = 10;
      this.formListLockTrial.memberNick = val.memberNick;
      this.formListLockTrial.pin = val.pin;
      this.formListLockTrial.isGetTrialGift = val.isGetTrialGift;
      this.formListLockTrial.isGetFormalGift = val.isGetFormalGift;
      this.formListLockTrial.startTime = val.startTime;
      this.formListLockTrial.endTime = val.endTime;
      this.formListLockTrial.skuId = val.skuId;
      this.formListLockTrial.orderId = val.orderId;
      this.formListLockTrial.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getParticipationLockTrial();
    },
    searchParticipationLockFormFixedPrice(val){
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.pin = val.pin;
      this.formList.joinTimeStart = val.joinTimeStart;
      this.formList.joinTimeEnd = val.joinTimeEnd;
      this.getParticipationLockFixedPrice();
    },
    //粉丝打卡
    searchParticipationLockFormFans(val){
      this.formListLockFans.current = 1;
      this.formListLockFans.size = 10;
      this.formListLockFans.memberNick = val.memberNick;
      this.formListLockFans.pin = val.pin;
      this.formListLockFans.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.formListLockFans.isPass = val.isPass;
      this.formListLockFans.isWin = val.isWin;
      this.formListLockFans.createStartTime = val.createStartTime;
      this.formListLockFans.createEndTime = val.createEndTime;
      this.getParticipationLockFans();
    },
    //入会有礼
    searchParticipationLockFormGift(val){
      this.formListLockFans.current = 1;
      this.formListLockFans.size = 10;
      this.formListLockFans.memberNick = val.memberNick;
      this.formListLockFans.pin = val.pin;
      this.formListLockFans.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.formListLockFans.isPass = val.isPass;
      this.formListLockFans.isWin = val.isWin;
      this.formListLockFans.createStartTime = val.createStartTime;
      this.formListLockFans.createEndTime = val.createEndTime;
      this.getParticipationLockGift();
    },
    showOrderDetails(val){
      this.formListLockFans.current = 1;
      this.formListLockFans.size = 10;
      this.formListLockFans.pin = val.pin;
      this.formListLockFans.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.formListLockFans.orderId = val.orderId;
      this.formListLockFans.orderState = val.orderState;
      this.formListLockFans.orderStartTime = val.orderStartTime;
      this.formListLockFans.orderEndTime = val.orderEndTime;
      this.formListLockFans.nickName = val.nickName || "";
      this.formListLockFans.memberNick = val.memberNick || "";
      this.formListLockFans.rootId = val.rootId || "";
      if (this.fitersChooseIF([68])){
         this.formListLockFans.startTime = val.orderStartTime;
         this.formListLockFans.endTime = val.orderEndTime;
       }
       this.showOrderDetail();
    },
    showOrderDetailsOne(val){
      this.formListLockFans.current = 1;
      this.formListLockFans.size = 10;
      this.formListLockFans.pin = val.pin;
      this.formListLockFans.joinStartTime = val.joinStartTime;
      this.formListLockFans.joinEndTime = val.joinEndTime;
      this.getRankingRecords();
    },
    //生命周期参与记录
    showOrderDetailsLife(val){
      this.formListLockFans.current = 1;
      this.formListLockFans.size = 10;
      this.formListLockFans.pin = val.pin;
      this.formListLockFans.memberNick = val.memberNick || "";
      this.formListLockFans.createStartTime = val.createStartTime;
      this.formListLockFans.createEndTime = val.createEndTime;
      this.getRankingRecordsLife();
    },
    //试用复购-订单明细
    searchParticipationLockFormOrder(val,type){
      this.formListLockOrder.current = 1;
      this.formListLockOrder.size = 10;
      this.formListLockOrder.pin = val.pin;
      this.formListLockOrder.orderId = val.orderId;
      this.formListLockOrder.orderStateList = val.orderStateList?val.orderStateList:[];
      this.formListLockOrder.orderEndTime = val.orderEndTime;
      this.formListLockOrder.orderStartTime = val.orderStartTime;
      this.formListLockOrder.memberNick = val.memberNick || "";
      this.formListLockOrder.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getParticipationLockTrialOrder(type);
    },
    //积分锁权-订单明细
    searchLockFormOrder(val){
      this.formLockOrder.current = 1;
      this.formLockOrder.size = 10;
      this.formLockOrder.customerPin = val.customerPin;
      this.formLockOrder.orderId = val.orderId;
      this.formLockOrder.orderStateList = val.orderStateList?val.orderStateList:[];
      this.formLockOrder.orderEndTime = val.orderEndTime;
      this.formLockOrder.orderStartTime = val.orderStartTime;
      this.formLockOrder.memberNick = val.memberNick || "";
      this.formLockOrder.rootId = val.rootId || "";
      this.getLocklOrderDetail();
    },
    //定时开奖参与记录查询
    searchParticipationOpenWinForm(val) {
      this.formOpenWin.current = 1;
      this.formOpenWin.size = 10;
      this.formOpenWin.memberNick = val.memberNick || "";
      this.formOpenWin.pin = val.pin || "";
      this.formOpenWin.isPass = val.isPass;
      this.formOpenWin.isWin = val.isWin;
      this.formOpenWin.isFillAddress = val.isFillAddress;
      this.formOpenWin.createStartTime = val.createStartTime;
      this.formOpenWin.createEndTime = val.createEndTime;
      this.formOpenWin.level = val.memberLevel;
      this.formOpenWin.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getParticipationOpenWin();
    },
    //定时开奖幸运值获取记录查询
    searchLuckForm(val, type) {
      // 重置
      if (type == "reset") {
        this.formLuck.activityType = "";
        this.formLuck.taskType = "";
      }
      this.formLuck.current = 1;
      this.formLuck.size = 10;
      this.formLuck.memberNick = val.memberNick;
      this.formLuck.pin = val.pin;
      this.formLuck.taskType = val.taskType;
      this.formLuck.createStartTime = val.createStartTime;
      this.formLuck.createEndTime = val.createEndTime;
      this.formLuck.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getLuckList();
    },
    // 参与记录查询(会员升级礼)
    searchMemberUpGrade(val) {
      // console.log(val);
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.pin = val.pin;
      this.formList.memberLevel = val.memberLevel ? val.memberLevel : '';
      this.formList.createStartTime = val.createStartTime;
      this.formList.createEndTime = val.createEndTime;
      this.formList.latestJoinStartTime = val.latestJoinStartTime;
      this.formList.latestJoinEndTime = val.latestJoinEndTime;
      this.formList.isUpgrades = val.isUpgrades;
      this.formList.isWin = val.isWin;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getMemberUpGrade();
    },
    // 参与记录(0元试用)
    searchZeroTrial(val) {
      this.formZeroList.current = 1;
      this.formZeroList.size = 10;
      // this.formZeroList.memberNick = val.memberNick;
      // this.formZeroList.pin = val.pin;
      // this.formZeroList.prizeName = val.prizeName;
      // this.formZeroList.isWin = val.isWin;
      // this.formZeroList.grantStatus = val.grantStatus;
      // this.formZeroList.isAddress = val.isAddress;
      // this.formZeroList.joinStartTime = val.joinStartTime;
      // this.formZeroList.joinEndTime = val.joinEndTime;
      // this.formZeroList.grantEndTime = val.grantEndTime;
      // this.formZeroList.grantStartTime = val.grantStartTime;
      // this.formZeroList.sendEndTime = val.sendEndTime;
      // this.formZeroList.level = val.memberLevel;
      this.formZeroList.receiverMobileList = this.formDataPhoneStr ? this.formDataPhoneStr.split(",") : [];
      // this.formZeroList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getZeroTrial();
    },
    resetZeroTrial() {
      this.formZeroList.receiverMobileList = []
      this.formDataPhoneStr = "";
      this.formZeroList.memberNick = ""
      this.formZeroList.pin = "";
      this.formZeroList.prizeName = "";
      this.formZeroList.isWin = "";
      this.formZeroList.grantStatus = "";
      this.formZeroList.isAddress = "";
      this.formZeroList.joinStartTime = "";
      this.formZeroList.joinEndTime = "";
      this.formZeroList.grantEndTime = "";
      this.formZeroList.grantStartTime = "";
      this.formZeroList.level = "";
      this.formZeroList.sellerLinkId = "";
      this.formZeroList.regionList = []
      this.$refs.zeroTrialRef.reData();
      this.getZeroTrial();
    },
    // 试用反馈(0元试用)
    searchZeroTrialDetail(val) {
      this.formZeroDetailList.current = 1;
      this.formZeroDetailList.size = 10;
      this.formZeroDetailList.memberNick = val.memberNick;
      this.formZeroDetailList.pin = val.pin;
      this.formZeroDetailList.prizeName = val.prizeName;
      this.formZeroDetailList.startTime = val.startTime;
      this.formZeroDetailList.endTime = val.endTime;
      this.formZeroDetailList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getZeroTrialDetail();
    },
    // 参与记录查询(情书贺卡)
    searchBilletDoux(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.finishedFlag = val.finishedFlag;
      this.getBilletDoux();
    },
    //门票支付记录
    searchFormTen(val){
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.customerPin = val.customerPin;
      this.formList.payStartTime = val.payStartTime;
      this.formList.payEndTime = val.payEndTime;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getBilletDouxTen();
    },
    // 出价记录查询
    searchFormEleven(val){
      this.formListEleven.current = 1;
      this.formListEleven.size = 10;
      this.formListEleven.isPass = val.isPass;
      this.formListEleven.bidTimeStart = val.bidTimeStart;
      this.formListEleven.bidTimeEnd = val.bidTimeEnd;
      this.formListEleven.passTimeStart = val.passTimeStart;
      this.formListEleven.passTimeEnd = val.passTimeEnd;
      this.formListEleven.memberNick = val.memberNick;
      this.formListEleven.pin = val.pin;
      this.formListEleven.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      console.log('5445455',this.formList);
      this.getBilletDouxEleven();
    },
    // 成交记录查询
    searchFormTwelve(val){
      this.formListTwelve.current = 1;
      this.formListTwelve.size = 10;
      this.formListTwelve.memberNick = val.memberNick;
      this.formListTwelve.pin = val.pin;
      this.formListTwelve.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.formListTwelve.passTimeStart = val.passTimeStart;
      this.formListTwelve.passTimeEnd = val.passTimeEnd;
      this.formListTwelve.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.formListTwelve.payTimeStart = val.payTimeStart;
      this.formListTwelve.payTimeEnd = val.payTimeEnd;
      this.formListTwelve.payStatus = val.payStatus;
      this.getBilletDouxTwelve();
    },

    // 获取记录查询(情书贺卡)
    searchBilletReceive(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.receiverMobile = val.receiverMobile;
      this.getBilletReceive();
    },
    searchAward(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      if(this.rowData.activityType == 63) {
        this.formList.sourcePopup = val.sourcePopup;
     } 
      this.distributionRecord();
    },
    // 派样下单记录查询方法
    searchSendBuyPay(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.skuId = val.skuId;
      this.formList.skuName = val.skuName;
      this.formList.orderId = val.orderId;
      this.formList.isCommitAddress = val.isCommitAddress;
      this.formList.orderTimeStart = val.orderTimeStart;
      this.formList.orderTimeEnd = val.orderTimeEnd;
      this.formList.receiveTimeStart = val.receiveTimeStart;
      this.formList.receiveTimeEnd = val.receiveTimeEnd;
      this.getSendBuyPayData();
    },
    // 派样下单记录列表查询方法
    getSendBuyPayData() {
      this.loading = true;
      this.formList.id = this.formList.activityId;
      // 派样传type 为 0
      let params = {
        ...this.formList,
        type: 0,
      };
      // 发送请求
      getOrderRecordPage(params)
        .then((res) => {
          this.sendBuyPayTable = [];
          if (res.code == 1) {
            this.sendBuyPayTable = res.data.records;
            this.totalSendBuyPayCount = Number(res.data.total);
            this.formList.current = Number(res.data.current);
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    handleCurrentSendBuyPay(val) {
      this.formList.current = val;
      this.getSendBuyPayData();
    },
    handleSizeSendBuyPay(val) {
      this.formList.size = val;
      this.getSendBuyPayData();
    },
    handleBuyPayPage(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getSendBuyPayData();
    },
    // 回购下单记录查询方法
    searchSendBuyRePay(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.skuId = val.skuId;
      this.formList.skuName = val.skuName;
      this.formList.orderId = val.orderId;
      this.formList.orderPaymentStart = val.orderPaymentStart;
      this.formList.orderPaymentEnd = val.orderPaymentEnd;
      this.formList.isWin = val.isWin;
      this.formList.isCommitAddress = val.isCommitAddress;
      this.formList.orderTimeStart = val.orderTimeStart;
      this.formList.orderTimeEnd = val.orderTimeEnd;
      this.formList.receiveTimeStart = val.receiveTimeStart;
      this.formList.receiveTimeEnd = val.receiveTimeEnd;
      this.getSendBuyRePayData();
    },
    // 回购下单记录列表查询方法
    getSendBuyRePayData() {
      this.loading = true;
      this.formList.id = this.formList.activityId;
      // 复购传type 为 1
      let params = {
        ...this.formList,
        type: 1,
      };
      // 发送请求
      getOrderRecordPage(params)
        .then((res) => {
          this.sendBuyRePayTable = [];
          if (res.code == 1) {
            this.sendBuyRePayTable = res.data.records;
            this.totalSendBuyRePayCount = Number(res.data.total);
            this.formList.current = Number(res.data.current);
            this.formList.size = Number(res.data.size);
            this.loading = false;
          } else {
            this.$message.error(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    handleCurrentSendBuyRePay(val) {
      this.formList.current = val;
      this.getSendBuyRePayData();
    },
    handleSizeSendBuyRePay(val) {
      this.formList.size = val;
      this.getSendBuyRePayData();
    },
    handleBuyRePayPage(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.getSendBuyRePayData();
    },

    // 打榜有礼 领奖记录 查询方法
    searchAwardFifteen(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.memberNick = val.memberNick;
      this.formList.rank = val.rank;
      this.formList.prizeType = val.prizeType;
      this.formList.status = val.status;
      this.formList.createTimeStart = val.createTimeStart;
      this.formList.createTimeEnd = val.createTimeEnd;
      this.formList.sendTimeStart = val.sendTimeStart;
      this.formList.sendTimeEnd = val.sendTimeEnd;
      this.formList.pin = val.pin;
      this.formList.prizeIds = val.prizeIds ? val.prizeIds.join(",") : "";
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.formList.winNumMinLimit = val.winNumMinLimit || "";
      this.formList.winNumMaxLimit = val.winNumMaxLimit || "";
      this.getWinRecord();
    },
    searchAwardExtra(val) {
      this.formExtra.current = 1;
      this.formExtra.size = 10;
      this.formExtra.memberNick = val.memberNick;
      this.formExtra.prizeType = val.prizeType;
      this.formExtra.status = val.status || "";
      this.formExtra.winTimeStart = val.winTimeStart;
      this.formExtra.winTimeEnd = val.winTimeEnd;
      this.formExtra.pin = val.pin;
      this.formExtra.prizeIds = val.prizeIds ? val.prizeIds.join(",") : "";
      this.formExtra.winNumMinLimit = val.winNumMinLimit || "";
      this.formExtra.winNumMaxLimit = val.winNumMaxLimit || "";
      // this.formExtra.prizeIds = val.prizeIds ? val.prizeIds.join(",") : "";
      this.getWinRecord();
    },
    getWinRecord() {
      this.loading = true;
      let params = null
      if(this.tabName === "twenty-two") {
        params = {
          ...this.formExtra,
        }
      } else {
        this.formList.id = this.formList.activityId;
        this.formList.prizeObjectType = 0;
        params = {
          ...this.formList,
          prizeObjectType: 0,
        }
      }
      this.searchCond = params;
      this.getWinRecordWinUserCount(params)
      getWinRecordPage(params).then((res) => {
        this.totalAward = 0;
        this.activityTable = [];
        if (res.code == 1) {
          this.activityTable = res.data.records;
          this.totalAward = Number(res.data.total);
          this.formList.current = Number(res.data.current);
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getPrizeNameList() {
      let params = {
        activityId: this.rowData.id,
      };
      getPrizeNames(params)
        .then((res) => {
          if (res.code == 1) {
            let prizeNames = res.data || [];
            prizeNames = prizeNames.filter((item)=>item.prizeType !=9)
            if (prizeNames.length) {
              this.prizeNames = prizeNames.map((item) => {
                return {
                  label: item.title,
                  value: item.id,
                };
              });
              if (this.fitersChooseIF([36])) {
                this.inputAwardFiften.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = this.prizeNames;
                  }
                });
              }
              if (this.fitersChooseIF([16, 17, 18, 23, 24, 27, 28, 31])) {
                this.inputAwardList.map((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = this.prizeNames
                  }
                });
                this.$nextTick(() => {
                  this.$refs.inputAwardOneRef.reData();
                });
              }
              let physicalPrizes = prizeNames.filter((item) => {
                return item.prizeType == 3;
              }).map((item) => {
                return {
                  label: item.title,
                  value: item.id,
                };
              });
              this.physicalPrizes = physicalPrizes;
              let prizeList = this.prizeNames;
              this.inputInkindInfo2.forEach((item) => {
                if (item.prop == "prizeIds") {
                  item.options = physicalPrizes;
                }
              });
              this.inputInkindInfo3.forEach((item) => {
                if (item.prop == "prizeIds") {
                  item.options = physicalPrizes;
                }
              });
              this.inputInkindList.forEach((item) => {
                if (item.prop == "prizeIds") {
                  item.options = physicalPrizes;
                }
              });
              this.zeroPrizeListForm.forEach((item) => {
                if (item.prop == "prizeIds") {
                  item.options = physicalPrizes;
                }
              });
              this.inputInkidNeedAwardList.forEach((item) => {
                if (item.prop == "prizeIds") {
                  item.options = physicalPrizes;
                }
              });
              this.inputMemberUpGradeMaterialList.forEach((item) => {
                if (item.prop == "prizeIds") {
                  item.options = physicalPrizes;
                }
              });
              if(this.activeName == 'thirdTis'){
                this.inputAwardTrial.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = this.prizeNames;
                  }
                });
                if(this.$refs.inputAwardTrialRef) {
                  this.$refs.inputAwardTrialRef.reData()
                }
              }
              this.inputInkindInfo3.forEach((item) => {
                if (item.prop == "prizeIds") {
                  item.options = physicalPrizes;
                }
              });
              if(this.activeName == 'third') {
                this.inputAwardList.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = prizeList;
                  }
                }); 
                this.inputAwardList1.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = prizeList;
                  }
                });
                this.inputMemberUpGradeList.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = prizeList;
                  }
                });
                this.inputPrizeLockList.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = prizeList;
                  }
                });
                this.inputAwardTwo.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = prizeList;
                  }
                });
                if(this.$refs.inputThirdRef) {
                  this.$refs.inputThirdRef.reData();
                }
                this.$refs.inputAwardOneRef.reData();
              }
              if(this.activeName == 'twenty-two') {
                this.inputAwardExtra.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = prizeList;
                  }
                });
                if(this.$refs.export_fun_extra) {
                  this.$refs.export_fun_extra.reData();
                }
              }
              if(this.activeName == 'sixteen') {
                this.inputAwardFour.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = prizeList;
                  }
                });
                if(this.$refs.sixteenInputRef) {
                  this.$refs.sixteenInputRef.reData();
                }
              }
              if(this.activeName == 'thirdTisOne') {
                this.inputAwardTrialOne.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = this.prizeNames;
                  }
                });
                if(this.$refs.inputAwardTrialOneRef) {
                  this.$refs.inputAwardTrialOneRef.reData();
                }
              }
              if(this.activeName == 'getRecord') {
                this.getRecordFormInfo.forEach((item) => {
                  if (item.prop == "prizeIds") {
                    item.options = prizeList;
                  }
                });
                if(this.$refs.getRecordFormRef) {
                  this.$refs.getRecordFormRef.reData();
                }
              }
            }
          }
        })
        .catch((err) => {});
    },
    // 打榜有礼 实物奖品 查询方法
    searchGoodRecordsPage(val) {
      console.log("val", val);
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.deliveryTimeStart = val.deliveryTimeStart
        ? val.deliveryTimeStart
        : "";
      this.formList.deliveryTimeEnd = val.deliveryTimeEnd
        ? val.deliveryTimeEnd
        : "";
      this.formList.sendTimeStart = val.sendTimeStart ? val.sendTimeStart : "";
      this.formList.sendTimeEnd = val.sendTimeEnd ? val.sendTimeEnd : "";
      this.formList.commitAddressFlag = val.commitAddressFlag;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.formList.prizeIds = val.prizeIds.length?val.prizeIds.join(','):"";
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.orderVenderId = val.orderVenderId;
      if (this.rowData.activityType == 39) {
        this.formList.status = val.status;
      } else {
        this.formList.prizeStatus = val.prizeStatus;
      }
      this.getGoodsRecord();
    },
    //实物奖品
    inKingRecord() {
      this.loading = true;
      let params = {
        ...this.formList,
      };
      if (this.rowData.activityType == 41) {
        params.grantStartTime = params.startTime;
        params.grantEndTime = params.endTime;
        delete params.startTime;
        delete params.endTime;
      }
      console.log("params", params);
      
      inKindList(params)
        .then((res) => {
          this.loading = false;
          this.totalInkind = Number(res.data.total);
          let records = res.data.records || [];
          this.inkindTable = records.map((item) => {
            item.prizeTitle = item.prizeTitle || item.title;
            return {
              ...item,
            };
          });
        })
        .catch((res) => {});
    },
    getGoodsRecord() {
      this.loading = true;
      let fn = getGoodsRecordPage;
      if (this.rowData.activityType == 39) {
        fn = goodRecords;
      }
      if (this.rowData.activityType == 62) {
        this.formList.commitAddressFlag = 1;
      }
      fn(this.formList).then((res) => {
        this.totalAward = 0;
        this.goodsRecordTable = [];  
        // 由于使用mock数据，code为14，这里直接处理数据
        let tableData = res.data.records;
        this.goodsRecordTable = tableData;
        this.totalAward = Number(res.data.total);
        this.loading = false;
      });
    },
    //获取抽卡机记录 
    opportunities(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.startTime = val.startTime ? val.startTime : "";
      this.formList.endTime = val.endTime ? val.endTime : "";
      this.formList.taskType = val.taskType ? val.taskType : "";
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.opportunitiesList();
    },
    // 改变趣味游戏记录
    changeFunGame(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.startTime = val.startTime ? val.startTime : "";
      this.formList.endTime = val.endTime ? val.endTime : "";
      this.formList.taskType = val.taskType ? val.taskType : "";
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.funGameList();
    },
    inputFunGameSearch(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.firstStartTime = val.firstStartTime ? val.firstStartTime : "";
      this.formList.firstEndTime = val.firstEndTime ? val.firstEndTime : "";
      this.formList.lastStartTime = val.lastStartTime ? val.lastStartTime : "";
      this.formList.lastEndTime = val.lastEndTime ? val.lastEndTime : "";
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.joinGameRecord();
    },
    inputCardSearch(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.joinTimeStart = val.joinTimeStart ? val.joinTimeStart : "";
      this.formList.joinTimeEnd = val.joinTimeEnd ? val.joinTimeEnd : "";
      this.formList.isPass = val.isPass !== null && val.isPass !== undefined && val.isPass !== "" ? Number(val.isPass) : "";
      this.inputCardList();
    },
    inputCardInviteSearch(val){
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.assistTimeStart = val.assistTimeStart ? val.assistTimeStart : "";
      this.formList.assistTimeEnd = val.assistTimeEnd ? val.assistTimeEnd : "";
      this.inputCardInviteList()
    },
    inputCardInviteList(){
      this.loading = true;
      getShoppingCartKoiInviteRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.cardInviteRecordTable = res.data.records;
          this.cardInviteRecordTotal = Number(res.data.total);
        })
        .catch((res) => {});
     },
    inputCardList(){
      this.loading = true;
      getShoppingCartKoiJoinRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.inputCardListTableChange = res.data.records;
          this.inputCardTotal = Number(res.data.total);
        })
        .catch((res) => {});
    },
    opportunitiesList() {
      this.loading = true;
      gameTaskRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.goodsRecordTableChange = res.data.records;
          this.totalAward = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //趣味游戏，机会抽奖记录
    funGameList() {
      this.loading = true;
      gameTaskRecord(this.formList)
        .then((res) => {
          this.loading = false;
          this.opportunity = res.data.records;
          this.opportunityTotal = Number(res.data.total);
        })
        .catch((res) => {});
    },
    // 加入游戏记录
    joinGameRecord() {
      this.loading = true;
      joinGameRecords(this.formList)
        .then((res) => {
          this.loading = false;
          this.joinGameRecordTable = res.data.records;
          this.joinGameRecordTotal = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //组队瓜分开团记录teamSpoils
    teamSpoils(val) {
      console.log("val", val);
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.createStartTime = val.createStartTime ? val.createStartTime : "";
      this.formList.createEndTime = val.createEndTime ? val.createEndTime : "";
      this.formList.finishStartTime = val.finishStartTime ? val.finishStartTime : "";
      this.formList.finishEndTime = val.finishEndTime ? val.finishEndTime : "";
      this.formList.isWin = val.isWin ? val.isWin : "";
      this.formList.isFinish = val.isFinish ? val.isFinish : "";
      this.formList.prizeName = val.prizeName || "";
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.teamFormationList();
    },
    teamFormationList() {
      this.loading = true;
      teamSharePrizeRecords(this.formList)
        .then((res) => {
          this.loading = false;
          this.teamList = res.data.records;
          this.totalTeam = Number(res.data.total);
        })
        .catch((res) => {});
    },
    taskCompletionChange(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.taskType = val.taskType ? val.taskType : "";
      this.formList.startTime = val.startTime ? val.startTime : "";
      this.formList.endTime = val.endTime ? val.endTime : "";
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      if (this.rowData.activityType != 65) {
        this.formList.type = val.type ? val.type : "";
      }
      // this.$refs.inputAwardTask.reData()
      this.getTaskCompletion();
    },
    // 任务完成记录
    getTaskCompletion() {
      this.loading = true;
      taskCompletion(this.formList)
        .then((res) => {
          this.loading = false;
          this.completionRecord = res.data.records;
          this.completionRecordTotalAward = Number(res.data.total);
        })
        .catch((res) => {});
    },
    //抽卡记录
    searchGachaRecordsPage(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.startTime = val.startTime ? val.startTime : "";
      this.formList.endTime = val.endTime ? val.endTime : "";
      this.formList.cardId = val.cardId ? val.cardId : "";
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.gachaRecords();
    },
    gachaRecords() {
      this.loading = true;
      gachaRecordList(this.formList)
        .then((res) => {
          this.loading = false;
          this.gachaRecoeds = res.data.records;
          this.totalAward = Number(res.data.total);
        })
        .catch((res) => {});
    },
    handlePageGoodsRecordGacha(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.gachaRecords();
    },
    //TODO:集卡参与用户卡片详情
    searchGoodRecordsPageOne(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
       this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getGoodsRecordOne();
    },
    getGoodsRecordOne() {
      this.loading = true;
      let fn = saveUserCardDetail;
      fn(this.formList).then((res) => {
        this.totalAward = 0;
        this.goodsRecordTableCard = [];
        let tableDataList = res.data.records
        // 同时赋值给goodsRecordTableCard，保留完整的数据结构
        this.goodsRecordTableCard = tableDataList.map(item => ({
          memberNick: item.memberNick || '',
          chaosPin: item.chaosPin || '',
          recordId: item.recordId || '',
          cardList: item.cardList || [],
          sellerLinkName:item.sellerLinkName || '-'
        }));
        this.totalAward = Number(res.data.total);
        this.loading = false;
      });
    },
    handlePageGoodsRecordCard(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.getGoodsRecordOne();
    },
    // 打榜有礼实物切换size
    handleGoodsRecordSize(val) {
      this.formList.size = val;
      this.getGoodsRecord();
    },
    // 打榜有礼实物切换current
    handleGoodsRecordCurrent(val) {
      this.formList.current = val;
      this.getGoodsRecord();
    },
    handlePageGoodsRecord(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.getGoodsRecord();
    },
    //获奖记录
    handlePageGoodsGacha(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.opportunitiesList();
    },
    handleCurrentJoinGameRecord(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.joinGameRecord();
    },
    handleCurrentInputCardList(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.inputCardList();
    },
    // 购物车锦鲤被邀请人记录切换size
    handlePageCardInviteRecord(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.inputCardInviteList();
    },
    // 趣味游戏，机会抽奖记录切换size
    handlePageFunGame(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.funGameList();
    },
    handlePageGoodsGachaTeam(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.teamFormationList();
    },
    handleSizeInviteDetailAllTree(pageInfo) {
      this.formList.size = pageInfo.pageSize;
      this.formList.current = pageInfo.pageNum;
      this.toGetInviteDetailOne();
    },
    // 打榜有礼领奖记录切换size
    handleFifteenWinRecordSize(val) {
      if(this.tabName == "twenty-two") {
        this.formExtra.size = val;
      } else {
        this.formList.size = val;
      }
      this.getWinRecord();
    },
    // 打榜有礼领奖记录切换current
    handleFifteenWinCurrent(val) {
      if(this.tabName == "twenty-two") {
        this.formExtra.current = val;
      } else {
        this.formList.current = val;
      }

      this.getWinRecord();
    },
    //发放记录
    searchAwardOne(val) {

      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.unlockOrderId = val.unlockOrderId || "";
      this.formList.orderState = val.orderState;
      this.formList.sellerLinkId = val.sellerLinkId || "";
      this.formList.isFillAddress = val.isFillAddress;
      this.formList.memberLevel = val.memberLevel || "";
      this.formList.prizeIds = val.prizeIds ? val.prizeIds.join(",") : "";
      this.formList.winNumMinLimit = val.winNumMinLimit || "";
      this.formList.winNumMaxLimit = val.winNumMaxLimit || "";
       if (this.fitersChooseIF([68])){
         this.formList.stageIndex = val.stageIndex;
       }
      // if (this.fitersChooseIF([16, 17, 18, 23, 24, 27, 28, 31])) {
      //   this.formList.prizeIds = val.prizeIds ? val.prizeIds.join(",") : "";
      // }
      if(this.fitersChooseIF([44, 45, 47, 48, 53])) {
        this.formList.sendStartTime = val.sendStartTime;
        this.formList.sendEndTime = val.sendEndTime;
      }
      // 积分锁权
      if (this.fitersChooseIF([45])) {
        this.formList.winStartTime = val.startTime;
        this.formList.winEndTime = val.endTime;
      } else {
        this.formList.startTime = val.startTime;
        this.formList.endTime = val.endTime;
      }
      // 下单抽奖-添加白名单字段
      if (this.fitersChooseIF([19,16,17,18])) {
        this.formList.isWhite = val.isWhite || "";
        this.formList.sellerLinkId = val.sellerLinkId || "";
        this.formList.orderVenderId = val.orderVenderId || "";
      }
      // 晒单有礼-订单号
      if (this.rowData.activityType == 41) {
        delete this.formList.unlockOrderId
        this.formList.unlockOrderIds = val.unlockOrderIds || "";
      }
      this.winningRecord();
    },
    // 试用礼-领奖记录
    searchAwardOneTrial(val){
        //试用礼--领奖记录
        this.formListTras.current = 1;
        this.formListTras.size = 10;
        this.formListTras.nickName = val.nickName;
        this.formListTras.pin = val.pin;
        this.formListTras.sendStatusList = val.sendStatusList?val.sendStatusList:[];
        this.formListTras.prizeType = val.prizeType;
        this.formListTras.prizeIds = val.prizeIds ? val.prizeIds.join(",") : "";
        this.formListTras.winStartTime = val.winStartTime;
        this.formListTras.winEndTime = val.winEndTime;
        this.formListTras.orderStateList = val.orderStateList?val.orderStateList:[];
        this.formListTras.orderId = val.orderId;
        this.formListTras.isWin = val.isWin;
        this.formListTras.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
        this.formListTras.winType = 0;
        this.formListTras.winNumMinLimit = val.winNumMinLimit || "";
        this.formListTras.winNumMaxLimit = val.winNumMaxLimit || "";
        this.trailLin();
            
    },
    // 正装礼-领奖记录
    searchAwardOneTrialOne(val){
      //试用礼--领奖记录
      this.formListTrasOne.current = 1;
      this.formListTrasOne.size = 10;
      this.formListTrasOne.nickName = val.nickName;
      this.formListTrasOne.sendStatusList = val.sendStatusList?val.sendStatusList:[];
      this.formListTrasOne.prizeType = val.prizeType;
      this.formListTrasOne.prizeIds = val.prizeIds ? val.prizeIds.join(",") : "";
      this.formListTrasOne.winStartTime = val.winStartTime;
      this.formListTrasOne.winEndTime = val.winEndTime;
      this.formListTrasOne.orderStateList = val.orderStateList?val.orderStateList:[];
      this.formListTrasOne.orderId = val.orderId;
      this.formListTrasOne.isWin = val.isWin;
      this.formListTrasOne.pin = val.pin;
      this.formListTrasOne.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.formListTrasOne.winType = 1
      this.formListTrasOne.winNumMinLimit = val.winNumMinLimit || "";
      this.formListTrasOne.winNumMaxLimit = val.winNumMaxLimit || "";
      this.trailLinOne();     
   },
    // 中奖记录 积分锁权 - 派样回购礼
    searchAwardFour(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.mobile = val.mobile;
      this.formList.memberLevel = val.memberLevel || "";
      this.formList.sendStatus = val.sendStatus;
      this.formList.deliveryStatus = val.deliveryStatus;
      this.formList.createTimeStart = val.createTimeStart;
      this.formList.createTimeEnd = val.createTimeEnd;
      this.formList.sendTimeStart = val.sendTimeStart;
      this.formList.sendTimeEnd = val.sendTimeEnd;
      this.formList.deliveryTimeStart = val.deliveryTimeStart;
      this.formList.deliveryTimeEnd = val.deliveryTimeEnd;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.formList.prizeIds = val.prizeIds ? val.prizeIds.join(",") : "";
      this.formList.winNumMinLimit = val.winNumMinLimit || "";
      this.formList.winNumMaxLimit = val.winNumMaxLimit || "";
      this.winningRecord();
    },
    //锁权记录
    searchLockRight(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.isPass = val.isPass;
      this.formList.isEnter = val.isEnter;
      this.formList.buyOrderNumMin = val.buyOrderNumMin;
      this.formList.buyOrderNumMax = val.buyOrderNumMax;
      this.formList.buyMoneyMin = val.buyMoneyMin;
      this.formList.buyMoneyMax = val.buyMoneyMax;
      this.formList.createTimeStart = val.createTimeStart;
      this.formList.createTimeEnd = val.createTimeEnd;
      this.lockRightRecord();
    },
    searchTakeGoods(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.inputTimeStart = val.inputTimeStart;
      this.formList.inputTimeEnd = val.inputTimeEnd;
      this.takeGoodsRecord();
    },
    searchInkind(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick ? val.memberNick : '';
      this.formList.memberLevel = val.memberLevel ? val.memberLevel : '';
      this.formList.startTime = val.startTime ? val.startTime : '';
      this.formList.endTime = val.endTime ? val.endTime : '';
      this.formList.status = val.status ? val.status : '';
      // this.formList.sendStatus = val.sendStatus;
      this.formList.orderId = val.orderId ? val.orderId : '';
      this.formList.orderState = val.orderState ? val.orderState : '';
      this.formList.prizeStatus = val.prizeStatus ? val.prizeStatus : '';
      this.formList.commitAddressFlag = val.commitAddressFlag;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.formList.createTimeStart = val.createTimeStart;
      this.formList.createTimeEnd = val.createTimeEnd;
      this.formList.sendTimeStart = val.sendTimeStart;
      this.formList.sendTimeEnd = val.sendTimeEnd;
      this.formList.deliveryTimeStart = val.deliveryTimeStart;
      this.formList.deliveryTimeEnd = val.deliveryTimeEnd;
      this.formList.orderVenderId = val.orderVenderId;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.prizeIds = val.prizeIds.length?val.prizeIds.join(','):"";
      this.formList.orderVenderId = val.orderVenderId;
       if(this.fitersChooseIF([44, 47, 48, 53,64,65,66])){
        this.formList.grantStartTime = val.deliveryTimeStart;
        this.formList.grantEndTime = val.deliveryTimeEnd;
       }


      if(this.fitersChooseIF([44, 47, 48, 53])){
        this.formList.grantStartTime = val.grantStartTime
        this.formList.grantEndTime = val.grantEndTime
      }
      this.inKingRecord();
    },
    searchUserInfo(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.improveRecord();
    },
    searchComment(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.orderId = val.orderId;
      this.formList.nickName = val.nickName;
      this.formList.filterType = val.filterType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.commentDraw();
    },
    searchCoupon(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.CoupondDtails();
    },
    searchSplit(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime
        ? val.startTime + " 00:00:00"
        : "";
      this.formList.endTime = val.endTime ? val.endTime + " 23:59:59" : "";
      this.CouponStatistics();
    },
    searchGroup(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.startTime = val.startTime
        ? val.startTime + " 00:00:00"
        : "";
      this.formList.endTime = val.endTime ? val.endTime + " 23:59:59" : "";
      if (this.fitersChooseIF([31])) {
        this.formList.status = val.status;
      }
      this.TeamDetails();
    },
    // 赠送记录
    searchGiftrecord(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin || "";
      this.formList.memberNick = val.memberNick || "";
      this.formList.taskType = val.taskType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      if(this.rowData.activityType==81) {
        this.formList.sellerLinkId = val.sellerLinkId;
        this.formList.memberLevel = val.memberLevel;
      }
      this.getGameTaskRecord();
    },
    //邀请统计
    searchAwardStatistics(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.memberLevel = val.memberLevel || "";
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.unlockOrderId = val.unlockOrderId;
      this.formList.orderState = val.orderState;
      this.formList.isFillAddress = val.isFillAddress;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.statistics();
    },
    //Note----邀请统计
    // 被邀请人明细
    inviteeDetailsSearch(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.invitePin = val.invitePin;
      this.formList.inviteNick = val.inviteNick;
      this.formList.pin = val.pin;
      this.formList.memberNick = val.memberNick;
      this.formList.isValidInvite = val.isValidInvite;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.toGetInviteDetail();
    },
    getJoinInviteDetail() {
      this.loading = true
      joinInviteDetail({...this.joinInviteForm,activityId:this.rowData.id}).then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.joinInvitesData = res.data.records;
          this.joinInviteTotal = Number(res.data.total);
        } else {
          this.$message.error(res.message);
        }
      }).catch((err) => {
        this.loading = false;
      });
    },
    joinInviteDetailsSearch(val) {
      this.current = 1;
      this.joinInviteForm.current = 1;
      this.joinInviteForm.size = 10;
      this.joinInviteForm.pin = val.pin ? val.pin : "";
      this.joinInviteForm.inviteePin = val.inviteePin ? val.inviteePin : "";
      this.joinInviteForm.isValid = val.isValid ? val.isValid : "";
      this.joinInviteForm.inviteStartTime = val.inviteStartTime ? val.inviteStartTime : "";
      this.joinInviteForm.inviteEndTime = val.inviteEndTime ? val.inviteEndTime : "";
      this.getJoinInviteDetail()
    },
    toGetInviteDetail() {
      this.loading = true
      getInviteDetail({startTime: this.getDateStr(-30) + " 00:00:00",endTime: this.getDateStr(0) + " 23:59:59",...this.formList}).then((res) => {
        this.loading = false;
        this.inviteeDetailsData = res.data.records;
        this.inviteeDetailsTotal = Number(res.data.total);
      });
    },
    // 组队瓜分被邀请人明细
    inviteeDetailsSearchOne(val) {
      this.current = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pinOrNick = val.pinOrNick;
      this.formList.invitePinOrNick = val.invitePinOrNick;
      this.formList.teamName = val.teamName;
      this.formList.createStartTime = val.createStartTime;
      this.formList.createEndTime = val.createEndTime;
      // this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.toGetInviteDetailOne();
    },
    toGetInviteDetailOne() {
      memberInviteDetails(this.formList).then((res) => {
        this.loading = false;
        this.inviteesData = res.data.records;
        this.inviteesDataTotal = Number(res.data.total);
      });
    },

    handleCurrentInviteDetail(val) {
      this.formList.current = val;
      this.toGetInviteDetail();
    },
    handleSizeInviteDetail(val) {
      this.formList.size = val;
      this.toGetInviteDetail();
    },
    handleSizeInviteDetailAll(val) {
      this.formList.current = val.pageNum;
      this.formList.size = val.pageSize;
      this.toGetInviteDetail();
    },
    handlePageJoinInvite(val) {
      this.joinInviteForm.current = val.pageNum;
      this.joinInviteForm.size = val.pageSize;
      this.getJoinInviteDetail();
    },
    statistics() {
      this.loading = true;
      // 只有邀请类的调awardRecNew接口
      if (this.rowData.activityType == 5 || this.rowData.activityType == 6) {
        invaidStatics(this.formList)
          .then((res) => {
            this.loading = false;
            this.invitationNum = res.data.records;
            this.totalAwardFor = Number(res.data.total);
          })
          .catch((res) => {});
        searchInvite({ id: this.rowData.id }).then((res) => {
          this.isTaskPrize = res.data.ruleDto.isTaskPrize;
        });
      }
    },
    // 兑换记录
    getList() {
      this.loading = true;
      getExchangeActivityRecord({
        ...this.formList,
        venderId: this.loginUserInfo.venderId,
        dataFrom: 2,
      }).then((res) => {
        this.exchangeList = res.data.records;
        this.loading = false;
        this.totalMail = Number(res.data.total);
      });
    },
    //标记发货
    changeShip(row) {
      // let id = row.id;
      this.$confirm("是否标记为发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
        customClass: "reverse-buttons",
      }).then(() => {
        DeliveryStatus(row.id, 1)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success(res.message);
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    // 取消发货
    cancelShip(row) {
      this.$confirm("是否取消发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
        customClass: "reverse-buttons",
      }).then(() => {
        DeliveryStatus(row.id, 1)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("取消发货成功");
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    // 兑换记录表单查询
    searchFormThir(val) {
      this.formList = { ...val, activityId: this.rowData.id };
      this.formList.size = 10;
      this.formList.current = 1;
      this.formList.sellerLinkId = val.sellerLinkId ? val.sellerLinkId : "";
      this.getList();
    },
    //分页事件
    handlePageExchange(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getList();
    },
    handleSizeExchange(val) {
      this.formList.size = val;
      this.getList();
    },
    handleCurrentExchange(val) {
      this.formList.current = val;
      this.getList();
    },
    //门票支付记录
    handlePageExchangeTen(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getBilletDouxTen();
    },
    // 出价记录查询
    handlePageExchangeEleven(val){
      this.formListEleven.size = val.pageSize;
      this.formListEleven.current = val.pageNum;
      this.getBilletDouxEleven();
    },
    // 出价记录查询
    handlePageExchangeTwelve(val){
      this.formListTwelve.size = val.pageSize;
      this.formListTwelve.current = val.pageNum;
      this.getBilletDouxTwelve();
    },
    // // 成交记录表单查询
    // searchFormTwelve(val){
    //   this.formListTwelve.size = val.pageSize;
    //   this.formListTwelve.current = val.pageNum;
    //   this.getBilletDouxTwelve();
    // },
    // 领取记录列表
    getRecord() {
      this.loading = true;
      const query = {
        size: this.formListRecord.size,
        current: this.formListRecord.current,
        activityId: this.rowData.id,
      };
      if (this.formListRecord.memberNick) {
        query.memberNick = this.formListRecord.memberNick;
      }
      if (this.formListRecord.prizeType) {
        query.prizeType = this.formListRecord.prizeType;
      }
      if (this.formListRecord.status) {
        query.status = this.formListRecord.status;
      }
      if (this.formListRecord.pin) {
        query.pin = this.formListRecord.pin;
      }
      // if (this.formListRecord.sellerLinkId) {
        query.sellerLinkId = this.formListRecord.sellerLinkId;
      // }
      if (this.formListRecord.startTime && this.formListRecord.endTime) {
        query.startTime = this.formListRecord.startTime;
        query.endTime = this.formListRecord.endTime;
      }
      if (this.formListRecord.hasOwnProperty('prizeObjectType')) {
        query.prizeObjectType = this.formListRecord.prizeObjectType;
      }
      if (this.formListRecord.birthGiftPrize) {
        query.birthGiftPrize = this.formListRecord.birthGiftPrize;
      }
      query.winNumMinLimit = this.formListRecord.winNumMinLimit;
      query.winNumMaxLimit = this.formListRecord.winNumMaxLimit;
      query.startTime = this.formListRecord.startTime;
      query.endTime = this.formListRecord.endTime;
      this.getWinPeoples(query)
      getUnlockRecord(query).then((res) => {
        if (res.code == 1) {
          this.getRecordList = res.data.records;
          this.totalRecord = Number(res.data.total);
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 领取记录表单
    searchFormRecord(val) {
      this.formListRecord = { ...val, activityId: this.rowData.id };
      this.formListRecord.size = 10;
      this.formListRecord.current = 1;
      this.getRecord();
    },
    //分页事件
    handleSizeExchangeRecord(val) {
      this.formListRecord.size = val;
      this.getRecord();
    },
    handleCurrentExchangeRecord(val) {
      this.formListRecord.current = val;
      this.getRecord();
    },
    handlePageExchangeRecord(pageInfo) {
      this.formListRecord.size = pageInfo.pageSize;
      this.formListRecord.current = pageInfo.pageNum;
      this.getRecord();
    },
    // 领取记录标记发放
    recordMark(row) {
      signIssuance({ id: row.recordId || row.id })
        .then((res) => {
          if (res && res.code == 1) {
            this.getRecord();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
    },
    //邀请明细分页
    handleSizeExchangeStatics(val) {
      this.formList1.size = val;
      this.invitationDetailNews();
    },
    handleCurrentExchangeStatics(val) {
      this.formList1.current = val;
      this.invitationDetailNews();
    },
    // 点击解密  name: 修改的字段名   objdata：数组的名称, params:接口的参数  item：点击的对象    index：数组传下标值
    handleDecrypt(name, objdata, item, index) {
      let params = "";
      // 资料明细 userInfoTable  实物奖品 inkindTable
      if (objdata == "userInfoTable") {
        params =
          "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "inkindTable" || objdata == "awardTable") {
        params =
          "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      } else if (objdata == "postOrderInfoTable") {
        let str = name.substring(5, name.length);
        params = str[0].toLowerCase() + str.substring(1, name.length);
      } else {
        params =
          "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      }
      this.$decrypt
        .decryptJHK({ decryptContent: item[`${params}`] })
        .then((res) => {
          this[`${objdata}`][index][`${name}`] = res.message;
        });
    },

    // 点击解密
    handleDecrypt1(name, item, index) {
      let params =
        "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);

      this.$decrypt
        .decryptJHK({ decryptContent: item[`${params}`] })
        .then((res) => {
          this.exchangeList[index][`${name}`] = res.message;
        });
    },

    // 折线图 tooltip
    //echarts图表自定义提示框函数
    echartIcon(params) {
      var str =
        '<div style="font-size:13px;color:#fff;font-weight:500;line-height:1;">' +
        params[0].name +
        "</div>";
      params.forEach((item) => {
        let value = item.value;
        let seriesName = item.seriesName;
        if (!item.value) {
          value = 0;
        }
        if (this.fitersChooseIF([25, 33, 32, 26])) {
          let dataList = [
            "点击用户下单转化率",
            "访客加购率",
            "点击率",
            "下单-支付转化率",
            "访客成交转化率",
          ];
          if (dataList.includes(seriesName)) {
            value = value * 100 + "%";
          }
        }
        if (this.fitersChooseIF([37])) {
          let dataList = ["收货回购率", "付款回购率"];
          if (dataList.includes(seriesName)) {
            value = value + "%";
          }
        }
        str += `<div style="font-size:13px;color::#fff;"><span style="display:inline-block;margin-right:8px;border-radius:20px;width:10px;height:10px;background-color:${item.color};"></span><span style="margin-right:4px">${seriesName}：</span><span style="font-weight:400">${value}</span></div>`;
      });
      return str;
    },
    getWinPeoples(params) {
      pointActivityPrizeWinUserCount(params).then((res) => {
        if (res.code == 1) {
          this.allWinPeoples = res.data || 0
        } else {
          this.$message.error(res.message);
        }
      })
      .catch((res) => {});
    },
    getWinRecordWinUserCount(params) {
      winRecordWinUserCount(params).then((res) => {
        if (res.code == 1) {
          this.rankWinPeoples = res.data || 0
        } else {
          this.$message.error(res.message);
        }
      })
      .catch((res) => {});
    },
    getTrialActivityRebuyWinRecordWinUserCount(params) {
      trialActivityRebuyWinRecordWinUserCount(params).then((res) => {
        if (res.code == 1) {
          this.trialWinPeoples = res.data || 0
        } else {
          this.$message.error(res.message);
        }
      })
      .catch((res) => {});
    }
  },
};
